// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../utils/config";

// const API_BASE = API_BASE_URL;

// /* ── Shared Input Style ─────────────────────────────────── */
// const inputStyle = {
//   width: "100%",
//   padding: "11px 14px",
//   borderRadius: 10,
//   border: "1.5px solid #e5e7eb",
//   fontSize: 14,
//   fontWeight: 500,
//   color: "#111827",
//   outline: "none",
//   background: "#fff",
//   boxSizing: "border-box",
//   transition: "border-color 0.2s",
// };

// const labelStyle = {
//   display: "block",
//   fontSize: 12,
//   fontWeight: 700,
//   color: "#6b7280",
//   marginBottom: 5,
//   letterSpacing: "0.03em",
// };

// const SectionHeader = ({ icon, title, subtitle, color = "#6366f1" }) => (
//   <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20, paddingBottom: 14, borderBottom: "1px solid #e5e7eb" }}>
//     <div style={{ width: 40, height: 40, borderRadius: 12, background: color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//       <span style={{ fontSize: 18 }}>{icon}</span>
//     </div>
//     <div>
//       <h3 style={{ margin: 0, fontSize: 15, fontWeight: 900, color: "#111827" }}>{title}</h3>
//       {subtitle && <p style={{ margin: 0, fontSize: 11, color: "#9ca3af", fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase" }}>{subtitle}</p>}
//     </div>
//   </div>
// );

// const Field = ({ label, children, error }) => (
//   <div style={{ display: "flex", flexDirection: "column" }}>
//     <label style={labelStyle}>{label}</label>
//     {children}
//     {error && <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, marginTop: 4 }}>{error}</span>}
//   </div>
// );

// // Role Match Popup Component
// const RoleMatchPopup = ({ isMatch, jobRole, candidateRoles, onClose, onViewMatchingJobs, onProceed }) => {
//   return (
//     <div style={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: "rgba(0,0,0,0.7)",
//       backdropFilter: "blur(8px)",
//       zIndex: 2000,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       animation: "fadeIn 0.3s ease"
//     }}>
//       <div style={{
//         background: "#fff",
//         borderRadius: 28,
//         maxWidth: 450,
//         width: "90%",
//         padding: 32,
//         textAlign: "center",
//         boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
//         animation: "scaleIn 0.3s ease",
//         position: "relative"
//       }}>
//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: 16,
//             right: 16,
//             width: 32,
//             height: 32,
//             borderRadius: "50%",
//             background: "#f1f5f9",
//             border: "none",
//             fontSize: 18,
//             fontWeight: 700,
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#64748b",
//             transition: "all 0.2s",
//             padding: 0
//           }}
//           onMouseEnter={(e) => {
//             e.target.style.background = "#e2e8f0";
//             e.target.style.color = "#0f172a";
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.background = "#f1f5f9";
//             e.target.style.color = "#64748b";
//           }}
//         >
//           ✕
//         </button>
        
//         {isMatch ? (
//           <>
//             <div style={{
//               width: 80,
//               height: 80,
//               background: "linear-gradient(135deg, #10b981, #059669)",
//               borderRadius: 40,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               margin: "0 auto 20px"
//             }}>
//               <span style={{ fontSize: 40 }}>🎉</span>
//             </div>
//             <h2 style={{ fontSize: 24, fontWeight: 900, color: "#0f172a", marginBottom: 12 }}>
//               Perfect Match!
//             </h2>
//             <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 8 }}>
//               Your profile role <strong style={{ color: "#10b981" }}>{candidateRoles?.join(", ")}</strong> matches the job role <strong style={{ color: "#10b981" }}>{jobRole}</strong>!
//             </p>
//             <p style={{ fontSize: 13, color: "#475569", marginBottom: 28 }}>
//               You're a great fit for this position. Proceed with your application.
//             </p>
//             <button
//               onClick={onProceed}
//               style={{
//                 width: "100%",
//                 padding: "14px 24px",
//                 background: "linear-gradient(135deg, #10b981, #059669)",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: 16,
//                 fontSize: 14,
//                 fontWeight: 800,
//                 cursor: "pointer"
//               }}
//             >
//               Continue Application →
//             </button>
//           </>
//         ) : (
//           <>
//             <div style={{
//               width: 80,
//               height: 80,
//               background: "linear-gradient(135deg, #f59e0b, #d97706)",
//               borderRadius: 40,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               margin: "0 auto 20px"
//             }}>
//               <span style={{ fontSize: 40 }}>⚠️</span>
//             </div>
//             <h2 style={{ fontSize: 24, fontWeight: 900, color: "#0f172a", marginBottom: 12 }}>
//               Role Mismatch
//             </h2>
//             <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 8 }}>
//               This job requires <strong style={{ color: "#f59e0b" }}>{jobRole}</strong>
//             </p>
//             <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 20 }}>
//               Your profile role: <strong style={{ color: "#ef4444" }}>{candidateRoles?.join(", ") || "Not specified"}</strong>
//             </p>
//             <div style={{ display: "flex", gap: 12, flexDirection: "column" }}>
//               <button
//                 onClick={onViewMatchingJobs}
//                 style={{
//                   width: "100%",
//                   padding: "14px 24px",
//                   background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 16,
//                   fontSize: 14,
//                   fontWeight: 800,
//                   cursor: "pointer"
//                 }}
//               >
//                 View Matching Jobs
//               </button>
//               <button
//                 onClick={onProceed}
//                 style={{
//                   width: "100%",
//                   padding: "14px 24px",
//                   background: "#f1f5f9",
//                   color: "#64748b",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: 16,
//                   fontSize: 14,
//                   fontWeight: 700,
//                   cursor: "pointer"
//                 }}
//               >
//                 Proceed Anyway
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes scaleIn {
//           from { transform: scale(0.9); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//       `}</style>
//     </div>
//   );
// };

// function ApplyingJob() {
//   const { id: jobId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [job, setJob] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [isCheckingExistence, setIsCheckingExistence] = useState(false);
//   const [candidateExists, setCandidateExists] = useState(false);
//   const [emailChecked, setEmailChecked] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const [verificationStep, setVerificationStep] = useState("");
//   const [otp, setOtp] = useState("");
//   const [loginPassword, setLoginPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   // Role match popup state
//   const [showRolePopup, setShowRolePopup] = useState(false);
//   const [candidateRoles, setCandidateRoles] = useState([]);
//   const [roleMatch, setRoleMatch] = useState(false);

//   const [formData, setFormData] = useState({
//     firstName: "", lastName: "", email: "", mobile: "", address: "",
//     highestQualification: "", institution: "", department: "", percentage: "", passingYear: "",
//     companyName: "", role: "", totalExperience: "", currentCompany: "", currentLocation: "",
//     currentCTC: "", expectedCTC: "", noticePeriod: "", skills: "", dateOfJoining: "",
//     resume: null, existingResume: ""
//   });

//   const [errors, setErrors] = useState({});

//   // Validation functions
//   const validateAlphabetsOnly = (value) => /^[A-Za-z\s]*$/.test(value);
//   const validateMobileNumber = (value) => /^[6-9]\d{9}$/.test(value);
//   const validateCTC = (value) => {
//     // Allow formats like 3.6, 25,000, 25k, range 1-100000
//     const numericValue = parseFloat(value.replace(/[^0-9.]/g, ''));
//     return numericValue >= 0 && numericValue <= 100000;
//   };

//   // Check if user came back from registration
//   useEffect(() => {
//     const registeredEmail = localStorage.getItem("registeredEmailForJob");
//     if (registeredEmail && !emailChecked) {
//       setFormData(prev => ({ ...prev, email: registeredEmail }));
//       setEmailChecked(true);
//       setCandidateExists(false);
//       setVerificationStep("");
//       localStorage.removeItem("registeredEmailForJob");
//       setMessage({ type: "success", text: "Registration successful! Please fill your job application details." });
//     }
//   }, []);

//   // Function to check role match
//   const checkRoleMatch = (candidateRoleArray, jobRole) => {
//     if (!candidateRoleArray || candidateRoleArray.length === 0) return false;
    
//     const jobRoleLower = jobRole?.toLowerCase() || "";
//     return candidateRoleArray.some(role => 
//       role?.toLowerCase() === jobRoleLower || 
//       jobRoleLower.includes(role?.toLowerCase()) ||
//       role?.toLowerCase().includes(jobRoleLower)
//     );
//   };

//   useEffect(() => {
//     const fetchJob = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/jobs/view/${jobId}`);
//         if (res.data.success) {
//           const jobData = res.data.jobPost;
//           setJob(jobData);
          
//           if (jobData.expiryDate) {
//             const today = new Date();
//             today.setHours(0, 0, 0, 0);
//             const expiry = new Date(jobData.expiryDate);
//             if (expiry < today) {
//               setError("This job has expired and is no longer accepting applications.");
//             }
//           }
//         }
//         else setError("Job post not found.");
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to load job details.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJob();

//     const token = localStorage.getItem("candidateToken");
//     if (token) {
//       setEmailChecked(true);
//       setCandidateExists(true);
//       setIsLoggedIn(true);
//       axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } })
//         .then(profileRes => {
//           const d = profileRes.data;
//           const [fname, ...lname] = (d.name || "").split(" ");
          
//           // Get candidate roles from profile
//           const userRoles = d.role || [];
//           setCandidateRoles(userRoles);
          
//           setFormData(prev => ({
//             ...prev,
//             email: d.email || prev.email,
//             firstName: fname || prev.firstName,
//             lastName: lname.join(" ") || prev.lastName,
//             mobile: d.phone || prev.mobile,
//             address: d.address || prev.address,
//             highestQualification: d.qualification || prev.highestQualification,
//             institution: d.institution || prev.institution,
//             department: d.department || prev.department,
//             percentage: d.percentage || prev.percentage,
//             passingYear: d.passingYear || prev.passingYear,
//             currentCompany: d.currentCompany || prev.currentCompany,
//             role: d.role?.[0] || prev.role,
//             totalExperience: d.experience || prev.totalExperience,
//             currentCTC: d.currentCTC || prev.currentCTC,
//             expectedCTC: d.expectedCTC || prev.expectedCTC,
//             noticePeriod: d.noticePeriod || prev.noticePeriod,
//             dateOfJoining: d.dateOfJoining || prev.dateOfJoining,
//             currentLocation: d.currentLocation || prev.currentLocation,
//             skills: d.skills || prev.skills,
//             existingResume: d.resume || ""
//           }));
//         })
//         .catch(() => { });
//     }
//   }, [jobId]);

//   // Show role match popup after login/auto-fill
//   useEffect(() => {
//     if (isLoggedIn && job && candidateRoles.length > 0 && !showRolePopup) {
//       const isMatch = checkRoleMatch(candidateRoles, job.role);
//       setRoleMatch(isMatch);
//       setShowRolePopup(true);
//     }
//   }, [isLoggedIn, job, candidateRoles]);

//   const handleEmailCheck = async () => {
//     if (!formData.email) return;
//     setIsCheckingExistence(true);
//     setMessage({ type: "", text: "" });
//     setIsLoggedIn(false);
//     try {
//       const res = await axios.post(`${API_BASE}/candidate/check-existence`, { email: formData.email });
//       if (res.data.exists) {
//         setCandidateExists(true);
//         setVerificationStep("password-prompt");
//         setMessage({ type: "info", text: "Welcome back! Please enter your password to continue." });
//       } else {
//         setCandidateExists(false);
//         const otpRes = await axios.post(`${API_BASE}/candidate/send-register-otp`, { email: formData.email });
//         if (otpRes.data.success) {
//           setVerificationStep("otp-prompt");
//           setMessage({ type: "success", text: "OTP sent to your email. Please verify." });
//         }
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Something went wrong. Please try again." });
//     } finally {
//       setIsCheckingExistence(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));

//     // Clear error for this field when user starts typing
//     setErrors(prev => ({ ...prev, [name]: "" }));

//     // Real-time validation
//     if (name === 'firstName' || name === 'lastName') {
//       if (value && !validateAlphabetsOnly(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only alphabets and spaces allowed" }));
//       } else if (value && value.length > 20) {
//         setErrors(prev => ({ ...prev, [name]: "Maximum 20 characters allowed" }));
//       }
//     }

//     if (name === 'mobile') {
//       if (value && !/^\d*$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only numbers allowed" }));
//       } else if (value && !/^[6-9]?\d{0,9}$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Must start with 6, 7, 8, or 9" }));
//       } else if (value && value.length === 10 && !validateMobileNumber(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Invalid mobile number format" }));
//       }
//     }

//     if (name === 'highestQualification' || name === 'institution' || name === 'department') {
//       if (value && value.length > 50) {
//         setErrors(prev => ({ ...prev, [name]: "Maximum 50 characters allowed" }));
//       }
//     }

//     if (name === 'percentage') {
//       const numValue = parseFloat(value);
//       if (value && (numValue < 0 || numValue > 100)) {
//         setErrors(prev => ({ ...prev, [name]: "Must be between 0 and 100" }));
//       }
//     }

//     if (name === 'passingYear') {
//       if (value && value.length !== 4) {
//         setErrors(prev => ({ ...prev, [name]: "Must be 4 digits" }));
//       } else if (value && !/^\d{4}$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only numbers allowed" }));
//       }
//     }

//     if (name === 'currentCTC' || name === 'expectedCTC') {
//       if (value && !validateCTC(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Must be between 1 and 100000" }));
//       }
//     }
//   };

//   const handleFileChange = (e) => {
//     setFormData(prev => ({ ...prev, resume: e.target.files[0] }));
//   };

//   const handleLogin = async (emailToLogin, password) => {
//     try {
//       const loginRes = await axios.post(`${API_BASE}/candidate/login`, {
//         email: emailToLogin || formData.email,
//         password: password
//       });
//       const token = loginRes.data.token;
//       const profileRes = await axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } });
//       const d = profileRes.data;
//       const [fname, ...lname] = (d.name || "").split(" ");
      
//       const userRoles = d.role || [];
//       setCandidateRoles(userRoles);
      
//       setFormData(prev => ({
//         ...prev,
//         firstName: fname, lastName: lname.join(" "),
//         mobile: d.phone || prev.mobile,
//         currentCompany: d.currentCompany || prev.currentCompany,
//         currentCTC: d.currentCTC || prev.currentCTC,
//         expectedCTC: d.expectedCTC || prev.expectedCTC,
//         skills: d.skills || prev.skills,
//         address: d.address || prev.address,
//         highestQualification: d.qualification || d.highestQualification || prev.highestQualification,
//         institution: d.institution || prev.institution,
//         department: d.department || prev.department,
//         percentage: d.percentage || prev.percentage,
//         passingYear: d.passingYear || prev.passingYear,
//         totalExperience: d.experience || prev.totalExperience,
//         currentLocation: d.currentLocation || prev.currentLocation,
//         noticePeriod: d.noticePeriod || prev.noticePeriod,
//         dateOfJoining: d.dateOfJoining || prev.dateOfJoining,
//         role: d.role?.[0] || prev.role,
//         existingResume: d.resume || ""
//       }));
//       localStorage.setItem("candidateToken", token);
//       localStorage.setItem("candidateId", d._id);
//       setIsLoggedIn(true);
//       setEmailChecked(true);
//       setVerificationStep("");
//       setMessage({ type: "success", text: "All details auto-filled from your profile! Review & apply." });
//     } catch (err) {
//       throw err;
//     }
//   };

//   const handleLoginPasswordSubmit = async (e) => {
//     if (e) e.preventDefault();
//     if (!loginPassword) {
//       setMessage({ type: "error", text: "Please enter your password." });
//       return;
//     }
//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       await handleLogin(formData.email, loginPassword);
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Invalid password. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleVerifyOtpSubmit = async (e) => {
//     if (e) e.preventDefault();
//     if (!otp) {
//       setMessage({ type: "error", text: "Please enter the verification OTP." });
//       return;
//     }
//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       const res = await axios.post(`${API_BASE}/candidate/verify-register-otp`, { 
//         email: formData.email, 
//         otp 
//       });
//       if (res.data.success) {
//         localStorage.setItem("tempEmailForRegistration", formData.email);
//         setMessage({ type: "success", text: "Email verified! Redirecting to registration..." });
        
//         setTimeout(() => {
//           navigate(`/candidate-register/${jobId}`, { 
//             state: { email: formData.email, fromJobApplication: true }
//           });
//         }, 1000);
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Invalid or expired OTP. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     if (e) e.preventDefault();

//     // Validate all fields before submission
//     const newErrors = {};

//     // Personal Details validation
//     if (!formData.firstName) {
//       newErrors.firstName = "First name is required";
//     } else if (!validateAlphabetsOnly(formData.firstName)) {
//       newErrors.firstName = "Only alphabets and spaces allowed";
//     } else if (formData.firstName.length > 20) {
//       newErrors.firstName = "Maximum 20 characters allowed";
//     }

//     if (!formData.lastName) {
//       newErrors.lastName = "Last name is required";
//     } else if (!validateAlphabetsOnly(formData.lastName)) {
//       newErrors.lastName = "Only alphabets and spaces allowed";
//     } else if (formData.lastName.length > 20) {
//       newErrors.lastName = "Maximum 20 characters allowed";
//     }

//     if (!formData.mobile) {
//       newErrors.mobile = "Mobile number is required";
//     } else if (!validateMobileNumber(formData.mobile)) {
//       newErrors.mobile = "Must be 10 digits starting with 6, 7, 8, or 9";
//     }

//     // Education validation
//     if (formData.highestQualification && formData.highestQualification.length > 100) {
//       newErrors.highestQualification = "Maximum 100 characters allowed";
//     }

//     if (formData.institution && formData.institution.length > 100) {
//       newErrors.institution = "Maximum 100 characters allowed";
//     }

//     if (formData.department && formData.department.length > 100) {
//       newErrors.department = "Maximum 100 characters allowed";
//     }

//     if (formData.percentage) {
//       const numValue = parseFloat(formData.percentage);
//       if (numValue < 0 || numValue > 100) {
//         newErrors.percentage = "Must be between 0 and 100";
//       }
//     }

//     if (formData.passingYear && formData.passingYear.length !== 4) {
//       newErrors.passingYear = "Must be 4 digits";
//     }

//     // CTC validation
//     if (formData.currentCTC && !validateCTC(formData.currentCTC)) {
//       newErrors.currentCTC = "Must be between 1 and 100000";
//     }

//     if (formData.expectedCTC && !validateCTC(formData.expectedCTC)) {
//       newErrors.expectedCTC = "Must be between 1 and 100000";
//     }

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       setMessage({ type: "error", text: "Please fix the errors before submitting." });
//       return;
//     }

//     if (job?.expiryDate) {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       const expiry = new Date(job.expiryDate);
//       if (expiry < today) {
//         setMessage({ type: "error", text: "This job has expired and cannot accept more applications." });
//         return;
//       }
//     }

//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       let candidateId = localStorage.getItem("candidateId");
//       let token = localStorage.getItem("candidateToken");

//       const data = new FormData();
//       data.append("jobId", job._id);
//       data.append("candidateId", candidateId);
//       Object.keys(formData).forEach(key => {
//         if (key === "resume") {
//           if (formData[key]) data.append("resume", formData[key]);
//         }
//         else if (key !== "existingResume") {
//           data.append(key, formData[key] || "");
//         }
//       });

//       const res = await axios.post(`${API_BASE}/applications/submit`, data, {
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (res.data.success) {
//         setMessage({ type: "success", text: "Application submitted successfully! Redirecting..." });
//         setTimeout(() => {
//           if ((job.assessmentIds && job.assessmentIds.length > 0) || job.assessmentId) {
//             const firstQuizId = job.assessmentIds?.[0]?._id || job.assessmentIds?.[0] || job.assessmentId?._id || job.assessmentId;
//             const resolvedQuizId = firstQuizId?._id || firstQuizId;
//             navigate(`/take-assessment/${jobId}/${res.data.application._id}/${resolvedQuizId}`);
//           } else {
//             navigate("/candidate-dashboard");
//           }
//         }, 2000);
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Failed to submit application. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleViewMatchingJobs = () => {
//     setShowRolePopup(false);
//     navigate("/candidate-dashboard");
//   };

//   const handleProceedApplication = () => {
//     setShowRolePopup(false);
//   };

//   if (loading) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)" }}>
//       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
//         <div style={{ position: "relative", width: 60, height: 60 }}>
//           <div style={{ position: "absolute", inset: 0, border: "4px solid rgba(139,92,246,0.2)", borderRadius: 16 }} />
//           <div style={{ position: "absolute", inset: 0, border: "4px solid transparent", borderTopColor: "#8b5cf6", borderRadius: 16, animation: "spin 0.8s linear infinite" }} />
//         </div>
//         <p style={{ color: "#a78bfa", fontSize: 11, fontWeight: 800, letterSpacing: "0.3em", textTransform: "uppercase" }}>Loading Application...</p>
//       </div>
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   );

//   if (error || !job) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", padding: 24 }}>
//       <div style={{ background: "#fff", borderRadius: 24, padding: 48, textAlign: "center", maxWidth: 400, width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.08)" }}>
//         <div style={{ fontSize: 48, marginBottom: 16 }}>{error.includes("expired") ? "⌛" : "⚠️"}</div>
//         <h2 style={{ fontSize: 22, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>
//           {error.includes("expired") ? "Job Expired" : "Job Not Found"}
//         </h2>
//         <p style={{ fontSize: 14, color: "#64748b", marginBottom: 24 }}>{error || "This job may have been archived."}</p>
//         <button onClick={() => navigate(-1)} style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", color: "#fff", border: "none", borderRadius: 12, padding: "12px 28px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Go Back</button>
//       </div>
//     </div>
//   );

//   const msgColors = {
//     success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d", icon: "✓" },
//     info: { bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8", icon: "ℹ" },
//     error: { bg: "#fef2f2", border: "#fecaca", text: "#dc2626", icon: "✕" },
//   };

//   // If email is checked and we have candidate details, show the application form
//   if (emailChecked && (isLoggedIn || (!candidateExists && formData.email))) {
//     return (
//       <>
//         {/* Role Match Popup */}
//         {showRolePopup && (
//           <RoleMatchPopup
//             isMatch={roleMatch}
//             jobRole={job?.role}
//             candidateRoles={candidateRoles}
//             onClose={() => setShowRolePopup(false)}
//             onViewMatchingJobs={handleViewMatchingJobs}
//             onProceed={handleProceedApplication}
//           />
//         )}

//         <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: "'Inter', system-ui, sans-serif" }}>
//           <style>{`
//             @keyframes spin { to { transform: rotate(360deg); } }
//             @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
//             @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//             input:focus, textarea:focus, select:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
//             .fld-input:hover { border-color: #a5b4fc !important; }
//             @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } .form-grid-2 { grid-template-columns: 1fr !important; } .form-grid-3 { grid-template-columns: 1fr !important; } }
//           `}</style>

//           {message.text && (() => {
//             const mc = msgColors[message.type] || msgColors.info;
//             return (
//               <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                   <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
//                   <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
//                 </div>
//                 <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
//               </div>
//             );
//           })()}

//           <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
//             <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
//             <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
//             <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
//               <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
//                 ← Back to Job
//               </button>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
//                 <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//                   Job Application
//                 </span>
//                 <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//                   ✓ Position Open
//                 </span>
//               </div>
//               <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
//                 Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
//               </h1>
//               <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
//                 {candidateExists
//                   ? "✅ Profile auto-filled — review and confirm your details below."
//                   : "📋 Fill in your details below to complete your application."}
//               </p>
//             </div>
//           </div>

//           <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
//             <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
//               <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />
              
//               <form onSubmit={handleSubmit} style={{ padding: "36px 40px" }}>
//                 {/* Section 1: Personal */}
//                 <div style={{ marginBottom: 36 }}>
//                   <SectionHeader icon="👤" title="Personal Details" subtitle="Basic contact information" color="linear-gradient(135deg,#6366f1,#8b5cf6)" />
//                   <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                     <Field label="First Name *" error={errors.firstName}>
//                       <input type="text" name="firstName" required value={formData.firstName} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.firstName ? "#dc2626" : "#e5e7eb" }} placeholder="John" />
//                     </Field>
//                     <Field label="Last Name *" error={errors.lastName}>
//                       <input type="text" name="lastName" required value={formData.lastName} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.lastName ? "#dc2626" : "#e5e7eb" }} placeholder="Doe" />
//                     </Field>
//                     <Field label="Email Address">
//                       <input type="email" name="email" value={formData.email} readOnly style={{ ...inputStyle, background: "#f8fafc", color: "#64748b" }} />
//                     </Field>
//                     <Field label="Mobile Number *" error={errors.mobile}>
//                       <input type="tel" name="mobile" required value={formData.mobile} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.mobile ? "#dc2626" : "#e5e7eb" }} placeholder="+91 98765 43210" />
//                     </Field>
//                   </div>
//                   <div style={{ marginTop: 18 }}>
//                     <Field label="Address / City">
//                       <input type="text" name="address" value={formData.address || ""} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="City, State, Country" />
//                     </Field>
//                   </div>
//                 </div>

//                 {/* Section 2: Education */}
//                 <div style={{ marginBottom: 36, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
//                   <SectionHeader icon="🎓" title="Education" subtitle="Academic qualifications" color="linear-gradient(135deg,#8b5cf6,#d946ef)" />
//                   <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                     <div style={{ gridColumn: "1 / -1" }}>
//                       <Field label="Highest Qualification" error={errors.highestQualification}>
//                         <input type="text" name="highestQualification" value={formData.highestQualification} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.highestQualification ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. B.Tech, MCA, MBBS" />
//                       </Field>
//                     </div>
//                     <Field label="Institution / College" error={errors.institution}>
//                       <input type="text" name="institution" value={formData.institution} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.institution ? "#dc2626" : "#e5e7eb" }} placeholder="University or College name" />
//                     </Field>
//                     <Field label="Department / Stream" error={errors.department}>
//                       <input type="text" name="department" value={formData.department} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.department ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. Computer Science" />
//                     </Field>
//                     <Field label="Percentage / CGPA" error={errors.percentage}>
//                       <input type="number" name="percentage" value={formData.percentage} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.percentage ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 85 or 8.5" />
//                     </Field>
//                     <Field label="Passing Year" error={errors.passingYear}>
//                       <input type="number" name="passingYear" value={formData.passingYear} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.passingYear ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 2022" />
//                     </Field>
//                   </div>
//                 </div>

//                 {/* Section 3: Experience */}
//                 <div style={{ marginBottom: 36, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
//                   <SectionHeader icon="💼" title="Work Experience" subtitle="Professional background" color="linear-gradient(135deg,#0ea5e9,#6366f1)" />
//                   <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                     <Field label="Current Company">
//                       <input type="text" name="currentCompany" value={formData.currentCompany} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="Your current employer" />
//                     </Field>
//                     <Field label="Current Role / Designation">
//                       <input type="text" name="role" value={formData.role} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. Staff Nurse, Developer" />
//                     </Field>
//                     <Field label="Total Experience (Yrs)">
//                       <input type="text" name="totalExperience" value={formData.totalExperience} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. 3 or 0.6 or 1-2" />
//                     </Field>
//                     <Field label="Current Location">
//                       <input type="text" name="currentLocation" value={formData.currentLocation} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="City, State" />
//                     </Field>
//                     <Field label="Current CTC" error={errors.currentCTC}>
//                       <input type="text" name="currentCTC" value={formData.currentCTC} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.currentCTC ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 6 LPA" />
//                     </Field>
//                     <Field label="Expected CTC" error={errors.expectedCTC}>
//                       <input type="text" name="expectedCTC" value={formData.expectedCTC} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.expectedCTC ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 9 LPA" />
//                     </Field>
//                     <Field label="Notice Period">
//                       <input type="text" name="noticePeriod" value={formData.noticePeriod} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. 30 Days, Immediate" />
//                     </Field>
//                     <Field label="Preferred Join Date">
//                       <input type="date" name="dateOfJoining" value={formData.dateOfJoining} onChange={handleChange} className="fld-input" style={inputStyle} min={new Date().toISOString().split('T')[0]} />
//                     </Field>
//                   </div>
//                   <div style={{ marginTop: 18 }}>
//                     <Field label="Key Skills (comma separated)">
//                       <input type="text" name="skills" value={formData.skills} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. React, Node.js, MongoDB" />
//                     </Field>
//                   </div>
//                 </div>

//                 {/* Section 4: Resume */}
//                 <div style={{ marginBottom: 36, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
//                   <SectionHeader icon="📄" title="Resume" subtitle="Upload your latest CV" color="linear-gradient(135deg,#10b981,#0ea5e9)" />
//                   <div style={{ position: "relative" }}>
//                     <input
//                       type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={handleFileChange}
//                       style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", zIndex: 5 }}
//                     />
//                     <div style={{
//                       border: "2px dashed", borderColor: formData.resume || formData.existingResume ? "#6366f1" : "#cbd5e1",
//                       borderRadius: 14, padding: "28px 20px", textAlign: "center",
//                       background: formData.resume || formData.existingResume ? "#f5f3ff" : "#fafafa",
//                       transition: "all 0.2s"
//                     }}>
//                       <div style={{ fontSize: 32, marginBottom: 8 }}>{formData.resume ? "✅" : formData.existingResume ? "📎" : "📤"}</div>
//                       {formData.resume ? (
//                         <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#6366f1" }}>
//                           {formData.resume.name} <span style={{ color: "#94a3b8", fontWeight: 500 }}>(ready to upload)</span>
//                         </p>
//                       ) : formData.existingResume ? (
//                         <>
//                           <p style={{ margin: "0 0 4px", fontSize: 13, fontWeight: 700, color: "#6366f1" }}>Previously uploaded resume found ✓</p>
//                           <p style={{ margin: 0, fontSize: 12, color: "#94a3b8" }}>You can upload a new one to replace it, or leave it as is.</p>
//                         </>
//                       ) : (
//                         <>
//                           <p style={{ margin: "0 0 4px", fontSize: 14, fontWeight: 700, color: "#374151" }}><span style={{ color: "#6366f1" }}>Click to upload</span> or drag & drop</p>
//                           <p style={{ margin: 0, fontSize: 12, color: "#94a3b8" }}>PDF, DOC, DOCX — Max 10MB</p>
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
//                   <button
//                     type="button" onClick={() => navigate(-1)}
//                     style={{ flex: 1, minWidth: 120, padding: "14px 20px", borderRadius: 12, border: "1.5px solid #e2e8f0", background: "#fff", fontSize: 14, fontWeight: 700, color: "#475569", cursor: "pointer", transition: "all 0.2s" }}>
//                     ← Cancel
//                   </button>
//                   <button
//                     type="submit" disabled={submitting}
//                     style={{
//                       flex: 2, minWidth: 200, padding: "14px 24px", borderRadius: 12, border: "none",
//                       background: submitting ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                       color: submitting ? "#94a3b8" : "#fff",
//                       fontSize: 14, fontWeight: 800, cursor: submitting ? "not-allowed" : "pointer",
//                       display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                       boxShadow: submitting ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                       transition: "all 0.2s", letterSpacing: "0.02em"
//                     }}>
//                     {submitting
//                       ? <><span style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#6366f1", borderRadius: "50%", display: "inline-block", animation: "spin 0.7s linear infinite" }} /> Submitting...</>
//                       : <>Submit Application →</>}
//                   </button>
//                 </div>
//               </form>
//             </div>

//             <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
//               Timely Health Recruitment Portal
//             </p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   /* ── EMAIL/OTP/PASSWORD SCREEN ── */
//   return (
//     <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "'Inter', system-ui, sans-serif" }}>
//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//         @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//         input:focus, textarea:focus, select:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
//         .fld-input:hover { border-color: #a5b4fc !important; }
//         @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } }
//       `}</style>

//       {message.text && (() => {
//         const mc = msgColors[message.type] || msgColors.info;
//         return (
//           <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
//               <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
//             </div>
//             <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
//           </div>
//         );
//       })()}

//       <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
//         <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
//         <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
//         <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
//           <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
//             ← Back to Job
//           </button>
//           <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
//             <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//               Job Application
//             </span>
//             <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//               ✓ Position Open
//             </span>
//           </div>
//           <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
//             Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
//           </h1>
//           <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
//             Enter your email to begin. Returning candidates will be auto-filled.
//           </p>
//         </div>
//       </div>

//       <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
//         <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
//           <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

//           {verificationStep === "" ? (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   📧
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter your Email</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   We'll check if you already have a profile.
//                 </p>
//               </div>

//               <div style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>Email Address *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>📧</span>
//                   <input
//                     type="email" name="email" required
//                     value={formData.email} onChange={handleChange}
//                     onKeyDown={e => e.key === "Enter" && handleEmailCheck()}
//                     className="fld-input"
//                     style={{ ...inputStyle, paddingLeft: 42 }}
//                     placeholder="candidate@example.com"
//                   />
//                 </div>

//                 <button
//                   onClick={handleEmailCheck}
//                   disabled={isCheckingExistence || !formData.email}
//                   style={{
//                     width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                     background: isCheckingExistence || !formData.email ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                     color: isCheckingExistence || !formData.email ? "#94a3b8" : "#fff",
//                     fontSize: 14, fontWeight: 800, cursor: isCheckingExistence || !formData.email ? "not-allowed" : "pointer",
//                     display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                     boxShadow: isCheckingExistence || !formData.email ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                     transition: "all 0.2s", letterSpacing: "0.02em"
//                   }}>
//                   {isCheckingExistence ? "Checking..." : "Continue →"}
//                 </button>
//               </div>
//             </div>
//           ) : verificationStep === "password-prompt" ? (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   🔒
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter Password</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   Welcome back! Enter your password to load your profile.
//                 </p>
//               </div>

//               <form onSubmit={handleLoginPasswordSubmit} style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>Password *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔒</span>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     required
//                     value={loginPassword}
//                     onChange={e => setLoginPassword(e.target.value)}
//                     style={{ ...inputStyle, paddingLeft: 42, paddingRight: 42 }}
//                     placeholder="••••••••"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", border: "none", background: "none", cursor: "pointer" }}
//                   >
//                     {showPassword ? "👁️" : "🙈"}
//                   </button>
//                 </div>

//                 <button type="submit" disabled={submitting || !loginPassword} style={{
//                   width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                   background: submitting || !loginPassword ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                   color: submitting || !loginPassword ? "#94a3b8" : "#fff",
//                   fontSize: 14, fontWeight: 800, cursor: submitting || !loginPassword ? "not-allowed" : "pointer",
//                   display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                   boxShadow: submitting || !loginPassword ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                   transition: "all 0.2s", letterSpacing: "0.02em"
//                 }}>
//                   {submitting ? "Logging in..." : "Log In & Continue →"}
//                 </button>
//               </form>
//             </div>
//           ) : (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   🔑
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Verify Email</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   We sent a 4-digit code to <strong>{formData.email}</strong>
//                 </p>
//               </div>

//               <form onSubmit={handleVerifyOtpSubmit} style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>OTP *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔑</span>
//                   <input
//                     type="text" required maxLength={4} value={otp} onChange={e => setOtp(e.target.value)}
//                     style={{ ...inputStyle, paddingLeft: 42, textAlign: "center", fontWeight: "bold" }}
//                     placeholder="••••"
//                   />
//                 </div>

//                 <button type="submit" disabled={submitting || !otp} style={{
//                   width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                   background: submitting || !otp ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                   color: submitting || !otp ? "#94a3b8" : "#fff",
//                   fontSize: 14, fontWeight: 800, cursor: submitting || !otp ? "not-allowed" : "pointer",
//                   display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                   boxShadow: submitting || !otp ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                   transition: "all 0.2s", letterSpacing: "0.02em"
//                 }}>
//                   {submitting ? "Verifying..." : "Verify & Continue →"}
//                 </button>
//               </form>
//             </div>
//           )}
//         </div>

//         <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
//           Timely Health Recruitment Portal
//         </p>
//       </div>
//     </div>
//   );
// }

// export default ApplyingJob;




// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../utils/config";

// const API_BASE = API_BASE_URL;

// /* ── Shared Input Style ─────────────────────────────────── */
// const inputStyle = {
//   width: "100%",
//   padding: "11px 14px",
//   borderRadius: 10,
//   border: "1.5px solid #e5e7eb",
//   fontSize: 14,
//   fontWeight: 500,
//   color: "#111827",
//   outline: "none",
//   background: "#fff",
//   boxSizing: "border-box",
//   transition: "border-color 0.2s",
// };

// const labelStyle = {
//   display: "block",
//   fontSize: 12,
//   fontWeight: 700,
//   color: "#6b7280",
//   marginBottom: 5,
//   letterSpacing: "0.03em",
// };

// const SectionHeader = ({ icon, title, subtitle, color = "#6366f1" }) => (
//   <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20, paddingBottom: 14, borderBottom: "1px solid #e5e7eb" }}>
//     <div style={{ width: 40, height: 40, borderRadius: 12, background: color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//       <span style={{ fontSize: 18 }}>{icon}</span>
//     </div>
//     <div>
//       <h3 style={{ margin: 0, fontSize: 15, fontWeight: 900, color: "#111827" }}>{title}</h3>
//       {subtitle && <p style={{ margin: 0, fontSize: 11, color: "#9ca3af", fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase" }}>{subtitle}</p>}
//     </div>
//   </div>
// );

// const Field = ({ label, children, error }) => (
//   <div style={{ display: "flex", flexDirection: "column" }}>
//     <label style={labelStyle}>{label}</label>
//     {children}
//     {error && <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, marginTop: 4 }}>{error}</span>}
//   </div>
// );

// // Role Match Popup Component
// const RoleMatchPopup = ({ isMatch, jobRole, candidateRoles, onClose, onViewMatchingJobs, onProceed }) => {
//   return (
//     <div style={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: "rgba(0,0,0,0.7)",
//       backdropFilter: "blur(8px)",
//       zIndex: 2000,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       animation: "fadeIn 0.3s ease"
//     }}>
//       <div style={{
//         background: "#fff",
//         borderRadius: 28,
//         maxWidth: 450,
//         width: "90%",
//         padding: 32,
//         textAlign: "center",
//         boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
//         animation: "scaleIn 0.3s ease",
//         position: "relative"
//       }}>
//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: 16,
//             right: 16,
//             width: 32,
//             height: 32,
//             borderRadius: "50%",
//             background: "#f1f5f9",
//             border: "none",
//             fontSize: 18,
//             fontWeight: 700,
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#64748b",
//             transition: "all 0.2s",
//             padding: 0
//           }}
//           onMouseEnter={(e) => {
//             e.target.style.background = "#e2e8f0";
//             e.target.style.color = "#0f172a";
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.background = "#f1f5f9";
//             e.target.style.color = "#64748b";
//           }}
//         >
//           ✕
//         </button>

//         {isMatch ? (
//           <>
//             <div style={{
//               width: 80,
//               height: 80,
//               background: "linear-gradient(135deg, #10b981, #059669)",
//               borderRadius: 40,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               margin: "0 auto 20px"
//             }}>
//               <span style={{ fontSize: 40 }}>🎉</span>
//             </div>
//             <h2 style={{ fontSize: 24, fontWeight: 900, color: "#0f172a", marginBottom: 12 }}>
//               Perfect Match!
//             </h2>
//             <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 8 }}>
//               Your profile role <strong style={{ color: "#10b981" }}>{candidateRoles?.join(", ")}</strong> matches the job role <strong style={{ color: "#10b981" }}>{jobRole}</strong>!
//             </p>
//             <p style={{ fontSize: 13, color: "#475569", marginBottom: 28 }}>
//               You're a great fit for this position. Proceed with your application.
//             </p>
//             <button
//               onClick={onProceed}
//               style={{
//                 width: "100%",
//                 padding: "14px 24px",
//                 background: "linear-gradient(135deg, #10b981, #059669)",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: 16,
//                 fontSize: 14,
//                 fontWeight: 800,
//                 cursor: "pointer"
//               }}
//             >
//               Continue Application →
//             </button>
//           </>
//         ) : (
//           <>
//             <div style={{
//               width: 80,
//               height: 80,
//               background: "linear-gradient(135deg, #f59e0b, #d97706)",
//               borderRadius: 40,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               margin: "0 auto 20px"
//             }}>
//               <span style={{ fontSize: 40 }}>⚠️</span>
//             </div>
//             <h2 style={{ fontSize: 24, fontWeight: 900, color: "#0f172a", marginBottom: 12 }}>
//               Role Mismatch
//             </h2>
//             <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 8 }}>
//               This job requires <strong style={{ color: "#f59e0b" }}>{jobRole}</strong>
//             </p>
//             <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6, marginBottom: 20 }}>
//               Your profile role: <strong style={{ color: "#ef4444" }}>{candidateRoles?.join(", ") || "Not specified"}</strong>
//             </p>
//             <div style={{ display: "flex", gap: 12, flexDirection: "column" }}>
//               <button
//                 onClick={onViewMatchingJobs}
//                 style={{
//                   width: "100%",
//                   padding: "14px 24px",
//                   background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 16,
//                   fontSize: 14,
//                   fontWeight: 800,
//                   cursor: "pointer"
//                 }}
//               >
//                 View Matching Jobs
//               </button>
//               <button
//                 onClick={onProceed}
//                 style={{
//                   width: "100%",
//                   padding: "14px 24px",
//                   background: "#f1f5f9",
//                   color: "#64748b",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: 16,
//                   fontSize: 14,
//                   fontWeight: 700,
//                   cursor: "pointer"
//                 }}
//               >
//                 Proceed Anyway
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes scaleIn {
//           from { transform: scale(0.9); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//       `}</style>
//     </div>
//   );
// };

// function ApplyingJob() {
//   const { id: jobId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [job, setJob] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [isCheckingExistence, setIsCheckingExistence] = useState(false);
//   const [candidateExists, setCandidateExists] = useState(false);
//   const [emailChecked, setEmailChecked] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const [verificationStep, setVerificationStep] = useState("");
//   const [otp, setOtp] = useState("");
//   const [loginPassword, setLoginPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   // Role match popup state
//   const [showRolePopup, setShowRolePopup] = useState(false);
//   const [candidateRoles, setCandidateRoles] = useState([]);
//   const [roleMatch, setRoleMatch] = useState(false);

//   const [formData, setFormData] = useState({
//     firstName: "", lastName: "", email: "", mobile: "", address: "",
//     highestQualification: "", institution: "", department: "", percentage: "", passingYear: "",
//     companyName: "", role: "", totalExperience: "", currentCompany: "", currentLocation: "",
//     currentCTC: "", expectedCTC: "", noticePeriod: "", skills: "", dateOfJoining: "",
//     resume: null, existingResume: ""
//   });

//   const [errors, setErrors] = useState({});

//   // Validation functions
//   const validateAlphabetsOnly = (value) => /^[A-Za-z\s]*$/.test(value);
//   const validateMobileNumber = (value) => /^[6-9]\d{9}$/.test(value);
//   const validateCTC = (value) => {
//     // Allow empty string, 0, and positive numbers up to 100000
//     if (value === "" || value === null || value === undefined) return true;
//     // Remove commas, spaces, and currency symbols
//     const cleanValue = String(value).replace(/[₹,\s]/g, '');
//     // Allow "0", "0.0", "0.00", "0k", "0.5k", etc.
//     if (cleanValue.toLowerCase() === '0k' || cleanValue === '0' || cleanValue === '0.0' || cleanValue === '0.00') return true;
//     // Parse numeric value
//     const numericValue = parseFloat(cleanValue);
//     // Allow values from 0 to 100000
//     return !isNaN(numericValue) && numericValue >= 0 && numericValue <= 100000;
//   };

//   // Check if user came back from registration
//   useEffect(() => {
//     const registeredEmail = localStorage.getItem("registeredEmailForJob");
//     if (registeredEmail && !emailChecked) {
//       setFormData(prev => ({ ...prev, email: registeredEmail }));
//       setEmailChecked(true);
//       setCandidateExists(false);
//       setVerificationStep("");
//       localStorage.removeItem("registeredEmailForJob");
//       setMessage({ type: "success", text: "Registration successful! Please fill your job application details." });
//     }
//   }, []);

//   // Function to check role match
//   const checkRoleMatch = (candidateRoleArray, jobRole) => {
//     if (!candidateRoleArray || candidateRoleArray.length === 0) return false;

//     const jobRoleLower = jobRole?.toLowerCase() || "";
//     return candidateRoleArray.some(role => 
//       role?.toLowerCase() === jobRoleLower || 
//       jobRoleLower.includes(role?.toLowerCase()) ||
//       role?.toLowerCase().includes(jobRoleLower)
//     );
//   };

//   useEffect(() => {
//     const fetchJob = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/jobs/view/${jobId}`);
//         if (res.data.success) {
//           const jobData = res.data.jobPost;
//           setJob(jobData);

//           if (jobData.expiryDate) {
//             const today = new Date();
//             today.setHours(0, 0, 0, 0);
//             const expiry = new Date(jobData.expiryDate);
//             if (expiry < today) {
//               setError("This job has expired and is no longer accepting applications.");
//             }
//           }
//         }
//         else setError("Job post not found.");
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to load job details.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJob();

//     const token = localStorage.getItem("candidateToken");
//     if (token) {
//       setEmailChecked(true);
//       setCandidateExists(true);
//       setIsLoggedIn(true);
//       axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } })
//         .then(profileRes => {
//           const d = profileRes.data;
//           const [fname, ...lname] = (d.name || "").split(" ");

//           // Get candidate roles from profile
//           const userRoles = d.role || [];
//           setCandidateRoles(userRoles);

//           setFormData(prev => ({
//             ...prev,
//             email: d.email || prev.email,
//             firstName: fname || prev.firstName,
//             lastName: lname.join(" ") || prev.lastName,
//             mobile: d.phone || prev.mobile,
//             address: d.address || prev.address,
//             highestQualification: d.qualification || prev.highestQualification,
//             institution: d.institution || prev.institution,
//             department: d.department || prev.department,
//             percentage: d.percentage || prev.percentage,
//             passingYear: d.passingYear || prev.passingYear,
//             currentCompany: d.currentCompany || prev.currentCompany,
//             role: d.role?.[0] || prev.role,
//             totalExperience: d.experience || prev.totalExperience,
//             currentCTC: d.currentCTC || prev.currentCTC,
//             expectedCTC: d.expectedCTC || prev.expectedCTC,
//             noticePeriod: d.noticePeriod || prev.noticePeriod,
//             dateOfJoining: d.dateOfJoining || prev.dateOfJoining,
//             currentLocation: d.currentLocation || prev.currentLocation,
//             skills: d.skills || prev.skills,
//             existingResume: d.resume || ""
//           }));
//         })
//         .catch(() => { });
//     }
//   }, [jobId]);

//   // Show role match popup after login/auto-fill
//   useEffect(() => {
//     if (isLoggedIn && job && candidateRoles.length > 0 && !showRolePopup) {
//       const isMatch = checkRoleMatch(candidateRoles, job.role);
//       setRoleMatch(isMatch);
//       setShowRolePopup(true);
//     }
//   }, [isLoggedIn, job, candidateRoles]);

//   const handleEmailCheck = async () => {
//     if (!formData.email) return;
//     setIsCheckingExistence(true);
//     setMessage({ type: "", text: "" });
//     setIsLoggedIn(false);
//     try {
//       const res = await axios.post(`${API_BASE}/candidate/check-existence`, { email: formData.email });
//       if (res.data.exists) {
//         setCandidateExists(true);
//         setVerificationStep("password-prompt");
//         setMessage({ type: "info", text: "Welcome back! Please enter your password to continue." });
//       } else {
//         setCandidateExists(false);
//         const otpRes = await axios.post(`${API_BASE}/candidate/send-register-otp`, { email: formData.email });
//         if (otpRes.data.success) {
//           setVerificationStep("otp-prompt");
//           setMessage({ type: "success", text: "OTP sent to your email. Please verify." });
//         }
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Something went wrong. Please try again." });
//     } finally {
//       setIsCheckingExistence(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));

//     // Clear error for this field when user starts typing
//     setErrors(prev => ({ ...prev, [name]: "" }));

//     // Real-time validation
//     if (name === 'firstName' || name === 'lastName') {
//       if (value && !validateAlphabetsOnly(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only alphabets and spaces allowed" }));
//       } else if (value && value.length > 20) {
//         setErrors(prev => ({ ...prev, [name]: "Maximum 20 characters allowed" }));
//       }
//     }

//     if (name === 'mobile') {
//       if (value && !/^\d*$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only numbers allowed" }));
//       } else if (value && !/^[6-9]?\d{0,9}$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Must start with 6, 7, 8, or 9" }));
//       } else if (value && value.length === 10 && !validateMobileNumber(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Invalid mobile number format" }));
//       }
//     }

//     if (name === 'highestQualification' || name === 'institution' || name === 'department') {
//       if (value && value.length > 50) {
//         setErrors(prev => ({ ...prev, [name]: "Maximum 50 characters allowed" }));
//       }
//     }

//     if (name === 'percentage') {
//       const numValue = parseFloat(value);
//       if (value && (numValue < 0 || numValue > 100)) {
//         setErrors(prev => ({ ...prev, [name]: "Must be between 0 and 100" }));
//       }
//     }

//     if (name === 'passingYear') {
//       if (value && value.length !== 4) {
//         setErrors(prev => ({ ...prev, [name]: "Must be 4 digits" }));
//       } else if (value && !/^\d{4}$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only numbers allowed" }));
//       }
//     }

//     if (name === 'currentCTC' || name === 'expectedCTC') {
//       if (value && !validateCTC(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Must be between 0 and 100000 (e.g., 0, 3.6, 25k, 12 LPA)" }));
//       }
//     }
//   };

//   const handleFileChange = (e) => {
//     setFormData(prev => ({ ...prev, resume: e.target.files[0] }));
//     // Clear resume error when file is selected
//     setErrors(prev => ({ ...prev, resume: "" }));
//   };

//   const handleLogin = async (emailToLogin, password) => {
//     try {
//       const loginRes = await axios.post(`${API_BASE}/candidate/login`, {
//         email: emailToLogin || formData.email,
//         password: password
//       });
//       const token = loginRes.data.token;
//       const profileRes = await axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } });
//       const d = profileRes.data;
//       const [fname, ...lname] = (d.name || "").split(" ");

//       const userRoles = d.role || [];
//       setCandidateRoles(userRoles);

//       setFormData(prev => ({
//         ...prev,
//         firstName: fname, lastName: lname.join(" "),
//         mobile: d.phone || prev.mobile,
//         currentCompany: d.currentCompany || prev.currentCompany,
//         currentCTC: d.currentCTC || prev.currentCTC,
//         expectedCTC: d.expectedCTC || prev.expectedCTC,
//         skills: d.skills || prev.skills,
//         address: d.address || prev.address,
//         highestQualification: d.qualification || d.highestQualification || prev.highestQualification,
//         institution: d.institution || prev.institution,
//         department: d.department || prev.department,
//         percentage: d.percentage || prev.percentage,
//         passingYear: d.passingYear || prev.passingYear,
//         totalExperience: d.experience || prev.totalExperience,
//         currentLocation: d.currentLocation || prev.currentLocation,
//         noticePeriod: d.noticePeriod || prev.noticePeriod,
//         dateOfJoining: d.dateOfJoining || prev.dateOfJoining,
//         role: d.role?.[0] || prev.role,
//         existingResume: d.resume || ""
//       }));
//       localStorage.setItem("candidateToken", token);
//       localStorage.setItem("candidateId", d._id);
//       setIsLoggedIn(true);
//       setEmailChecked(true);
//       setVerificationStep("");
//       setMessage({ type: "success", text: "All details auto-filled from your profile! Review & apply." });
//     } catch (err) {
//       throw err;
//     }
//   };

//   const handleLoginPasswordSubmit = async (e) => {
//     if (e) e.preventDefault();
//     if (!loginPassword) {
//       setMessage({ type: "error", text: "Please enter your password." });
//       return;
//     }
//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       await handleLogin(formData.email, loginPassword);
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Invalid password. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleVerifyOtpSubmit = async (e) => {
//     if (e) e.preventDefault();
//     if (!otp) {
//       setMessage({ type: "error", text: "Please enter the verification OTP." });
//       return;
//     }
//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       const res = await axios.post(`${API_BASE}/candidate/verify-register-otp`, { 
//         email: formData.email, 
//         otp 
//       });
//       if (res.data.success) {
//         localStorage.setItem("tempEmailForRegistration", formData.email);
//         setMessage({ type: "success", text: "Email verified! Redirecting to registration..." });

//         setTimeout(() => {
//           navigate(`/candidate-register/${jobId}`, { 
//             state: { email: formData.email, fromJobApplication: true }
//           });
//         }, 1000);
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Invalid or expired OTP. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     if (e) e.preventDefault();

//     // Validate all fields before submission
//     const newErrors = {};

//     // Personal Details validation
//     if (!formData.firstName) {
//       newErrors.firstName = "First name is required";
//     } else if (!validateAlphabetsOnly(formData.firstName)) {
//       newErrors.firstName = "Only alphabets and spaces allowed";
//     } else if (formData.firstName.length > 20) {
//       newErrors.firstName = "Maximum 20 characters allowed";
//     }

//     if (!formData.lastName) {
//       newErrors.lastName = "Last name is required";
//     } else if (!validateAlphabetsOnly(formData.lastName)) {
//       newErrors.lastName = "Only alphabets and spaces allowed";
//     } else if (formData.lastName.length > 20) {
//       newErrors.lastName = "Maximum 20 characters allowed";
//     }

//     if (!formData.mobile) {
//       newErrors.mobile = "Mobile number is required";
//     } else if (!validateMobileNumber(formData.mobile)) {
//       newErrors.mobile = "Must be 10 digits starting with 6, 7, 8, or 9";
//     }

//     // Education validation
//     if (formData.highestQualification && formData.highestQualification.length > 100) {
//       newErrors.highestQualification = "Maximum 100 characters allowed";
//     }

//     if (formData.institution && formData.institution.length > 100) {
//       newErrors.institution = "Maximum 100 characters allowed";
//     }

//     if (formData.department && formData.department.length > 100) {
//       newErrors.department = "Maximum 100 characters allowed";
//     }

//     if (formData.percentage) {
//       const numValue = parseFloat(formData.percentage);
//       if (numValue < 0 || numValue > 100) {
//         newErrors.percentage = "Must be between 0 and 100";
//       }
//     }

//     if (formData.passingYear && formData.passingYear.length !== 4) {
//       newErrors.passingYear = "Must be 4 digits";
//     }

//     // CTC validation - Now allows 0
//     if (formData.currentCTC && !validateCTC(formData.currentCTC)) {
//       newErrors.currentCTC = "Must be between 0 and 100000 (e.g., 0, 3.6, 25k, 12 LPA)";
//     }

//     if (formData.expectedCTC && !validateCTC(formData.expectedCTC)) {
//       newErrors.expectedCTC = "Must be between 0 and 100000 (e.g., 0, 3.6, 25k, 12 LPA)";
//     }


//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       setMessage({ type: "error", text: "Please fill all required fileds." });
//       return;
//     }

//     if (job?.expiryDate) {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       const expiry = new Date(job.expiryDate);
//       if (expiry < today) {
//         setMessage({ type: "error", text: "This job has expired and cannot accept more applications." });
//         return;
//       }
//     }

//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       let candidateId = localStorage.getItem("candidateId");
//       let token = localStorage.getItem("candidateToken");

//       const data = new FormData();
//       data.append("jobId", job._id);
//       data.append("candidateId", candidateId);
//       Object.keys(formData).forEach(key => {
//         if (key === "resume") {
//           if (formData[key]) data.append("resume", formData[key]);
//         }
//         else if (key !== "existingResume") {
//           data.append(key, formData[key] || "");
//         }
//       });

//       const res = await axios.post(`${API_BASE}/applications/submit`, data, {
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (res.data.success) {
//         setMessage({ type: "success", text: "Application submitted successfully! Redirecting..." });
//         setTimeout(() => {
//           if ((job.assessmentIds && job.assessmentIds.length > 0) || job.assessmentId) {
//             const firstQuizId = job.assessmentIds?.[0]?._id || job.assessmentIds?.[0] || job.assessmentId?._id || job.assessmentId;
//             const resolvedQuizId = firstQuizId?._id || firstQuizId;
//             navigate(`/take-assessment/${jobId}/${res.data.application._id}/${resolvedQuizId}`);
//           } else {
//             navigate("/candidate-dashboard");
//           }
//         }, 2000);
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Failed to submit application. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleViewMatchingJobs = () => {
//     setShowRolePopup(false);
//     navigate("/all-jobs");
//   };

//   const handleProceedApplication = () => {
//     setShowRolePopup(false);
//   };

//   if (loading) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)" }}>
//       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
//         <div style={{ position: "relative", width: 60, height: 60 }}>
//           <div style={{ position: "absolute", inset: 0, border: "4px solid rgba(139,92,246,0.2)", borderRadius: 16 }} />
//           <div style={{ position: "absolute", inset: 0, border: "4px solid transparent", borderTopColor: "#8b5cf6", borderRadius: 16, animation: "spin 0.8s linear infinite" }} />
//         </div>
//         <p style={{ color: "#a78bfa", fontSize: 11, fontWeight: 800, letterSpacing: "0.3em", textTransform: "uppercase" }}>Loading Application...</p>
//       </div>
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   );

//   if (error || !job) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", padding: 24 }}>
//       <div style={{ background: "#fff", borderRadius: 24, padding: 48, textAlign: "center", maxWidth: 400, width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.08)" }}>
//         <div style={{ fontSize: 48, marginBottom: 16 }}>{error.includes("expired") ? "⌛" : "⚠️"}</div>
//         <h2 style={{ fontSize: 22, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>
//           {error.includes("expired") ? "Job Expired" : "Job Not Found"}
//         </h2>
//         <p style={{ fontSize: 14, color: "#64748b", marginBottom: 24 }}>{error || "This job may have been archived."}</p>
//         <button onClick={() => navigate(-1)} style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", color: "#fff", border: "none", borderRadius: 12, padding: "12px 28px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Go Back</button>
//       </div>
//     </div>
//   );

//   const msgColors = {
//     success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d", icon: "✓" },
//     info: { bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8", icon: "ℹ" },
//     error: { bg: "#fef2f2", border: "#fecaca", text: "#dc2626", icon: "✕" },
//   };

//   // If email is checked and we have candidate details, show the application form
//   if (emailChecked && (isLoggedIn || (!candidateExists && formData.email))) {
//     return (
//       <>
//         {/* Role Match Popup */}
//         {showRolePopup && (
//           <RoleMatchPopup
//             isMatch={roleMatch}
//             jobRole={job?.role}
//             candidateRoles={candidateRoles}
//             onClose={() => setShowRolePopup(false)}
//             onViewMatchingJobs={handleViewMatchingJobs}
//             onProceed={handleProceedApplication}
//           />
//         )}

//         <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: "'Inter', system-ui, sans-serif" }}>
//           <style>{`
//             @keyframes spin { to { transform: rotate(360deg); } }
//             @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
//             @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//             input:focus, textarea:focus, select:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
//             .fld-input:hover { border-color: #a5b4fc !important; }
//             @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } .form-grid-2 { grid-template-columns: 1fr !important; } .form-grid-3 { grid-template-columns: 1fr !important; } }
//           `}</style>

//           {message.text && (() => {
//             const mc = msgColors[message.type] || msgColors.info;
//             return (
//               <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                   <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
//                   <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
//                 </div>
//                 <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
//               </div>
//             );
//           })()}

//           <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
//             <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
//             <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
//             <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
//               <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
//                 ← Back to Job
//               </button>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
//                 <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//                   Job Application
//                 </span>
//                 <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//                   ✓ Position Open
//                 </span>
//               </div>
//               <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
//                 Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
//               </h1>
//               <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
//                 {candidateExists
//                   ? "✅ Profile auto-filled — review and confirm your details below."
//                   : "📋 Fill in your details below to complete your application."}
//               </p>
//             </div>
//           </div>

//           <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
//             <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
//               <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

//               <form onSubmit={handleSubmit} style={{ padding: "36px 40px" }}>
//                 {/* Section 1: Personal */}
//                 <div style={{ marginBottom: 36 }}>
//                   <SectionHeader icon="👤" title="Personal Details" subtitle="Basic contact information" color="linear-gradient(135deg,#6366f1,#8b5cf6)" />
//                   <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                     <Field label="First Name *" error={errors.firstName}>
//                       <input type="text" name="firstName" required value={formData.firstName} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.firstName ? "#dc2626" : "#e5e7eb" }} placeholder="John" />
//                     </Field>
//                     <Field label="Last Name *" error={errors.lastName}>
//                       <input type="text" name="lastName" required value={formData.lastName} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.lastName ? "#dc2626" : "#e5e7eb" }} placeholder="Doe" />
//                     </Field>
//                     <Field label="Email Address">
//                       <input type="email" name="email" value={formData.email} readOnly style={{ ...inputStyle, background: "#f8fafc", color: "#64748b" }} />
//                     </Field>
//                     <Field label="Mobile Number *" error={errors.mobile}>
//                       <input type="tel" name="mobile" required value={formData.mobile} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.mobile ? "#dc2626" : "#e5e7eb" }} placeholder="+91 98765 43210" />
//                     </Field>
//                   </div>
//                   <div style={{ marginTop: 18 }}>
//                     <Field label="Address / City">
//                       <input type="text" name="address" value={formData.address || ""} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="City, State, Country" />
//                     </Field>
//                   </div>
//                 </div>

//                 {/* Section 2: Education */}
//                 <div style={{ marginBottom: 36, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
//                   <SectionHeader icon="🎓" title="Education" subtitle="Academic qualifications" color="linear-gradient(135deg,#8b5cf6,#d946ef)" />
//                   <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                     <div style={{ gridColumn: "1 / -1" }}>
//                       <Field label="Highest Qualification" error={errors.highestQualification}>
//                         <input type="text" name="highestQualification" value={formData.highestQualification} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.highestQualification ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. B.Tech, MCA, MBBS" />
//                       </Field>
//                     </div>
//                     <Field label="Institution / College" error={errors.institution}>
//                       <input type="text" name="institution" value={formData.institution} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.institution ? "#dc2626" : "#e5e7eb" }} placeholder="University or College name" />
//                     </Field>
//                     <Field label="Department / Stream" error={errors.department}>
//                       <input type="text" name="department" value={formData.department} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.department ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. Computer Science" />
//                     </Field>
//                     <Field label="Percentage / CGPA" error={errors.percentage}>
//                       <input type="number" name="percentage" value={formData.percentage} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.percentage ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 85 or 8.5" />
//                     </Field>
//                     <Field label="Passing Year" error={errors.passingYear}>
//                       <input type="number" name="passingYear" value={formData.passingYear} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.passingYear ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 2022" />
//                     </Field>
//                   </div>
//                 </div>

//                 {/* Section 3: Experience */}
//                 <div style={{ marginBottom: 36, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
//                   <SectionHeader icon="💼" title="Work Experience" subtitle="Professional background" color="linear-gradient(135deg,#0ea5e9,#6366f1)" />
//                   <div className="form-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                     <Field label="Current Company">
//                       <input type="text" name="currentCompany" value={formData.currentCompany} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="Your current employer" />
//                     </Field>
//                     <Field label="Current Role / Designation">
//                       <input type="text" name="role" value={formData.role} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. Staff Nurse, Developer" />
//                     </Field>
//                     <Field label="Total Experience (Yrs)">
//                       <input type="text" name="totalExperience" value={formData.totalExperience} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. 3 or 0.6 or 1-2" />
//                     </Field>
//                     <Field label="Current Location">
//                       <input type="text" name="currentLocation" value={formData.currentLocation} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="City, State" />
//                     </Field>
//                     <Field label="Current CTC" error={errors.currentCTC}>
//                       <input type="text" name="currentCTC" value={formData.currentCTC} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.currentCTC ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 0, 3.6, 25k, 12 LPA" />
//                     </Field>
//                     <Field label="Expected CTC" error={errors.expectedCTC}>
//                       <input type="text" name="expectedCTC" value={formData.expectedCTC} onChange={handleChange} className="fld-input" style={{ ...inputStyle, borderColor: errors.expectedCTC ? "#dc2626" : "#e5e7eb" }} placeholder="e.g. 0, 5.5, 30k, 15 LPA" />
//                     </Field>
//                     <Field label="Notice Period">
//                       <input type="text" name="noticePeriod" value={formData.noticePeriod} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. 30 Days, Immediate" />
//                     </Field>
//                     <Field label="Preferred Join Date">
//                       <input type="date" name="dateOfJoining" value={formData.dateOfJoining} onChange={handleChange} className="fld-input" style={inputStyle} min={new Date().toISOString().split('T')[0]} />
//                     </Field>
//                   </div>
//                   <div style={{ marginTop: 18 }}>
//                     <Field label="Key Skills (comma separated)">
//                       <input type="text" name="skills" value={formData.skills} onChange={handleChange} className="fld-input" style={inputStyle} placeholder="e.g. React, Node.js, MongoDB" />
//                     </Field>
//                   </div>
//                 </div>

//                 {/* Section 4: Resume */}
//                 <div style={{ marginBottom: 36, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
//                   <SectionHeader icon="📄" title="Resume" subtitle="Upload your latest CV *" color="linear-gradient(135deg,#10b981,#0ea5e9)" />
//                   <div style={{ position: "relative" }}>
//                     <input
//                       type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={handleFileChange}
//                       style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", zIndex: 5 }}
//                     />
//                     <div style={{
//                       border: "2px dashed", borderColor: errors.resume ? "#ef4444" : (formData.resume || formData.existingResume ? "#6366f1" : "#cbd5e1"),
//                       borderRadius: 14, padding: "28px 20px", textAlign: "center",
//                       background: errors.resume ? "#fef2f2" : (formData.resume || formData.existingResume ? "#f5f3ff" : "#fafafa"),
//                       transition: "all 0.2s"
//                     }}>
//                       <div style={{ fontSize: 32, marginBottom: 8 }}>{formData.resume ? "✅" : formData.existingResume ? "📎" : "📤"}</div>
//                       {formData.resume ? (
//                         <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#6366f1" }}>
//                           {formData.resume.name} <span style={{ color: "#94a3b8", fontWeight: 500 }}>(ready to upload)</span>
//                         </p>
//                       ) : formData.existingResume ? (
//                         <>
//                           <p style={{ margin: "0 0 4px", fontSize: 13, fontWeight: 700, color: "#6366f1" }}>Previously uploaded resume found ✓</p>
//                           <p style={{ margin: 0, fontSize: 12, color: "#94a3b8" }}>You can upload a new one to replace it, or leave it as is.</p>
//                         </>
//                       ) : (
//                         <>
//                           <p style={{ margin: "0 0 4px", fontSize: 14, fontWeight: 700, color: "#374151" }}><span style={{ color: "#6366f1" }}>Click to upload</span> or drag & drop</p>
//                           <p style={{ margin: 0, fontSize: 12, color: "#94a3b8" }}>PDF, DOC, DOCX — Max 10MB</p>
//                         </>
//                       )}
//                     </div>
//                     {errors.resume && (
//                       <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, marginTop: 4, display: "block" }}>{errors.resume}</span>
//                     )}
//                   </div>
//                 </div>

//                 <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
//                   <button
//                     type="button" onClick={() => navigate(-1)}
//                     style={{ flex: 1, minWidth: 120, padding: "14px 20px", borderRadius: 12, border: "1.5px solid #e2e8f0", background: "#fff", fontSize: 14, fontWeight: 700, color: "#475569", cursor: "pointer", transition: "all 0.2s" }}>
//                     ← Cancel
//                   </button>
//                   <button
//                     type="submit" disabled={submitting}
//                     style={{
//                       flex: 2, minWidth: 200, padding: "14px 24px", borderRadius: 12, border: "none",
//                       background: submitting ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                       color: submitting ? "#94a3b8" : "#fff",
//                       fontSize: 14, fontWeight: 800, cursor: submitting ? "not-allowed" : "pointer",
//                       display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                       boxShadow: submitting ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                       transition: "all 0.2s", letterSpacing: "0.02em"
//                     }}>
//                     {submitting
//                       ? <><span style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#6366f1", borderRadius: "50%", display: "inline-block", animation: "spin 0.7s linear infinite" }} /> Submitting...</>
//                       : <>Submit Application →</>}
//                   </button>
//                 </div>
//               </form>
//             </div>

//             <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
//               Timely Health Recruitment Portal
//             </p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   /* ── EMAIL/OTP/PASSWORD SCREEN ── */
//   return (
//     <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "'Inter', system-ui, sans-serif" }}>
//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//         @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//         input:focus, textarea:focus, select:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
//         .fld-input:hover { border-color: #a5b4fc !important; }
//         @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } }
//       `}</style>

//       {message.text && (() => {
//         const mc = msgColors[message.type] || msgColors.info;
//         return (
//           <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
//               <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
//             </div>
//             <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
//           </div>
//         );
//       })()}

//       <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
//         <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
//         <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
//         <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
//           <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
//             ← Back to Job
//           </button>
//           <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
//             <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//               Job Application
//             </span>
//             <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//               ✓ Position Open
//             </span>
//           </div>
//           <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
//             Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
//           </h1>
//           <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
//             Enter your email to begin. Returning candidates will be auto-filled.
//           </p>
//         </div>
//       </div>

//       <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
//         <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
//           <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

//           {verificationStep === "" ? (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   📧
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter your Email</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   We'll check if you already have a profile.
//                 </p>
//               </div>

//               <div style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>Email Address *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>📧</span>
//                   <input
//                     type="email" name="email" required
//                     value={formData.email} onChange={handleChange}
//                     onKeyDown={e => e.key === "Enter" && handleEmailCheck()}
//                     className="fld-input"
//                     style={{ ...inputStyle, paddingLeft: 42 }}
//                     placeholder="candidate@example.com"
//                   />
//                 </div>

//                 <button
//                   onClick={handleEmailCheck}
//                   disabled={isCheckingExistence || !formData.email}
//                   style={{
//                     width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                     background: isCheckingExistence || !formData.email ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                     color: isCheckingExistence || !formData.email ? "#94a3b8" : "#fff",
//                     fontSize: 14, fontWeight: 800, cursor: isCheckingExistence || !formData.email ? "not-allowed" : "pointer",
//                     display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                     boxShadow: isCheckingExistence || !formData.email ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                     transition: "all 0.2s", letterSpacing: "0.02em"
//                   }}>
//                   {isCheckingExistence ? "Checking..." : "Continue →"}
//                 </button>
//               </div>
//             </div>
//           ) : verificationStep === "password-prompt" ? (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   🔒
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter Password</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   Welcome back! Enter your password to load your profile.
//                 </p>
//               </div>

//               <form onSubmit={handleLoginPasswordSubmit} style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>Password *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔒</span>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     required
//                     value={loginPassword}
//                     onChange={e => setLoginPassword(e.target.value)}
//                     style={{ ...inputStyle, paddingLeft: 42, paddingRight: 42 }}
//                     placeholder="••••••••"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", border: "none", background: "none", cursor: "pointer" }}
//                   >
//                     {showPassword ? "👁️" : "🙈"}
//                   </button>
//                 </div>

//                 <button type="submit" disabled={submitting || !loginPassword} style={{
//                   width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                   background: submitting || !loginPassword ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                   color: submitting || !loginPassword ? "#94a3b8" : "#fff",
//                   fontSize: 14, fontWeight: 800, cursor: submitting || !loginPassword ? "not-allowed" : "pointer",
//                   display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                   boxShadow: submitting || !loginPassword ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                   transition: "all 0.2s", letterSpacing: "0.02em"
//                 }}>
//                   {submitting ? "Logging in..." : "Log In & Continue →"}
//                 </button>
//               </form>
//             </div>
//           ) : (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   🔑
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Verify Email</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   We sent a 4-digit code to <strong>{formData.email}</strong>
//                 </p>
//               </div>

//               <form onSubmit={handleVerifyOtpSubmit} style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>OTP *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔑</span>
//                   <input
//                     type="text" required maxLength={4} value={otp} onChange={e => setOtp(e.target.value)}
//                     style={{ ...inputStyle, paddingLeft: 42, textAlign: "center", fontWeight: "bold" }}
//                     placeholder="••••"
//                   />
//                 </div>

//                 <button type="submit" disabled={submitting || !otp} style={{
//                   width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                   background: submitting || !otp ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                   color: submitting || !otp ? "#94a3b8" : "#fff",
//                   fontSize: 14, fontWeight: 800, cursor: submitting || !otp ? "not-allowed" : "pointer",
//                   display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                   boxShadow: submitting || !otp ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                   transition: "all 0.2s", letterSpacing: "0.02em"
//                 }}>
//                   {submitting ? "Verifying..." : "Verify & Continue →"}
//                 </button>
//               </form>
//             </div>
//           )}
//         </div>

//         <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
//           Timely Health Recruitment Portal
//         </p>
//       </div>
//     </div>
//   );
// }
// export default ApplyingJob;



// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../utils/config";

// const API_BASE = API_BASE_URL;

// /* ── Shared Input Style ─────────────────────────────────── */
// const inputStyle = {
//   width: "100%",
//   padding: "11px 14px",
//   borderRadius: 10,
//   border: "1.5px solid #e5e7eb",
//   fontSize: 14,
//   fontWeight: 500,
//   color: "#111827",
//   outline: "none",
//   background: "#fff",
//   boxSizing: "border-box",
//   transition: "border-color 0.2s",
// };

// const labelStyle = {
//   display: "block",
//   fontSize: 12,
//   fontWeight: 700,
//   color: "#6b7280",
//   marginBottom: 5,
//   letterSpacing: "0.03em",
// };

// const SectionHeader = ({ icon, title, subtitle, color = "#6366f1" }) => (
//   <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20, paddingBottom: 14, borderBottom: "1px solid #e5e7eb", flexWrap: "wrap", overflow: "hidden" }}>
//     <div style={{ width: 40, height: 40, borderRadius: 12, background: color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//       <span style={{ fontSize: 18 }}>{icon}</span>
//     </div>
//     <div style={{ flex: 1, minWidth: "100px", overflow: "hidden" }}>
//       <h3 style={{ margin: 0, fontSize: 15, fontWeight: 900, color: "#111827", wordBreak: "break-word" }}>{title}</h3>
//       {subtitle && <p style={{ margin: 0, fontSize: 11, color: "#9ca3af", fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase", wordBreak: "break-word" }}>{subtitle}</p>}
//     </div>
//   </div>
// );

// const Field = ({ label, children, error, required, note }) => (
//   <div style={{ display: "flex", flexDirection: "column", width: "100%", overflow: "hidden" }}>
//     <label style={labelStyle}>{label} {required && <span style={{ color: "#dc2626" }}>*</span>}</label>
//     {children}
//     {note && <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 4, fontStyle: "italic" }}>{note}</p>}
//     {error && <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, marginTop: 4 }}>{error}</span>}
//   </div>
// );

// // OTP Popup Component
// const OtpPopup = ({ email, onVerify, onResend, onClose, loading }) => {
//   const [otp, setOtp] = useState("");
//   const [error, setError] = useState("");
//   const [resendDisabled, setResendDisabled] = useState(false);
//   const [timer, setTimer] = useState(30);

//   useEffect(() => {
//     if (resendDisabled) {
//       const interval = setInterval(() => {
//         setTimer(prev => {
//           if (prev <= 1) {
//             setResendDisabled(false);
//             clearInterval(interval);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [resendDisabled]);

//   const handleVerify = () => {
//     if (!otp || otp.length !== 4) {
//       setError("Please enter a valid 4-digit OTP");
//       return;
//     }
//     setError("");
//     onVerify(otp);
//   };

//   const handleResend = () => {
//     setResendDisabled(true);
//     setTimer(30);
//     onResend();
//   };

//   return (
//     <div style={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: "rgba(0,0,0,0.6)",
//       backdropFilter: "blur(8px)",
//       zIndex: 2000,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       animation: "fadeIn 0.3s ease"
//     }}>
//       <div style={{
//         background: "#fff",
//         borderRadius: 24,
//         maxWidth: 420,
//         width: "90%",
//         padding: 32,
//         textAlign: "center",
//         boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
//         animation: "scaleIn 0.3s ease",
//         position: "relative"
//       }}>
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: 12,
//             right: 12,
//             width: 32,
//             height: 32,
//             borderRadius: "50%",
//             background: "#f1f5f9",
//             border: "none",
//             fontSize: 18,
//             fontWeight: 700,
//             cursor: "pointer",
//             color: "#64748b",
//             transition: "all 0.2s",
//             padding: 0,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center"
//           }}
//           onMouseEnter={(e) => {
//             e.target.style.background = "#e2e8f0";
//             e.target.style.color = "#0f172a";
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.background = "#f1f5f9";
//             e.target.style.color = "#64748b";
//           }}
//         >
//           ✕
//         </button>

//         <div style={{
//           width: 72,
//           height: 72,
//           background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
//           borderRadius: 36,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           margin: "0 auto 16px"
//         }}>
//           <span style={{ fontSize: 32 }}>📧</span>
//         </div>

//         <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>
//           Verify Your Email
//         </h2>
//         <p style={{ fontSize: 14, color: "#64748b", marginBottom: 4 }}>
//           We've sent a 4-digit verification code to
//         </p>
//         <p style={{ fontSize: 14, fontWeight: 700, color: "#6366f1", marginBottom: 24, wordBreak: "break-all" }}>
//           {email}
//         </p>

//         <div style={{ marginBottom: 20 }}>
//           <label style={{ ...labelStyle, textAlign: "left" }}>Enter OTP *</label>
//           <input
//             type="text"
//             maxLength={4}
//             value={otp}
//             onChange={(e) => {
//               const val = e.target.value.replace(/\D/g, '');
//               setOtp(val);
//               setError("");
//             }}
//             style={{
//               ...inputStyle,
//               textAlign: "center",
//               fontSize: 24,
//               fontWeight: 900,
//               letterSpacing: 8,
//               padding: "12px",
//               borderColor: error ? "#dc2626" : "#e5e7eb"
//             }}
//             placeholder="••••"
//           />
//           {error && <p style={{ fontSize: 12, color: "#dc2626", fontWeight: 600, marginTop: 6 }}>{error}</p>}
//         </div>

//         <button
//           onClick={handleVerify}
//           disabled={loading || !otp}
//           style={{
//             width: "100%",
//             padding: "14px",
//             borderRadius: 12,
//             border: "none",
//             background: loading || !otp ? "#e2e8f0" : "linear-gradient(135deg, #6366f1, #8b5cf6)",
//             color: loading || !otp ? "#94a3b8" : "#fff",
//             fontSize: 14,
//             fontWeight: 800,
//             cursor: loading || !otp ? "not-allowed" : "pointer",
//             transition: "all 0.2s"
//           }}
//         >
//           {loading ? "Verifying..." : "Verify & Continue →"}
//         </button>

//         <div style={{ marginTop: 16 }}>
//           <button
//             onClick={handleResend}
//             disabled={resendDisabled}
//             style={{
//               background: "none",
//               border: "none",
//               color: resendDisabled ? "#94a3b8" : "#6366f1",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: resendDisabled ? "not-allowed" : "pointer",
//               transition: "all 0.2s"
//             }}
//           >
//             {resendDisabled ? `Resend OTP in ${timer}s` : "Resend OTP"}
//           </button>
//         </div>
//       </div>
//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes scaleIn {
//           from { transform: scale(0.9); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//       `}</style>
//     </div>
//   );
// };

// function ApplyingJob() {
//   const { id: jobId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [job, setJob] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [isCheckingExistence, setIsCheckingExistence] = useState(false);
//   const [candidateExists, setCandidateExists] = useState(false);
//   const [emailChecked, setEmailChecked] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const [verificationStep, setVerificationStep] = useState("");
//   const [otp, setOtp] = useState("");
//   const [loginPassword, setLoginPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   // Popup state
//   const [showOtpPopup, setShowOtpPopup] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);

//   // Form data with firstName, lastName, address
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     mobile: "",
//     address: "",
//     resume: null
//   });

//   const [errors, setErrors] = useState({});

//   const validateMobile = (value) => /^[6-9]\d{9}$/.test(value);
//   const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//   const validateAlphabetsOnly = (value) => /^[A-Za-z\s]*$/.test(value);

//   useEffect(() => {
//     const registeredEmail = localStorage.getItem("registeredEmailForJob");
//     if (registeredEmail && !emailChecked) {
//       setFormData(prev => ({ ...prev, email: registeredEmail }));
//       setEmailChecked(true);
//       setCandidateExists(false);
//       setVerificationStep("");
//       localStorage.removeItem("registeredEmailForJob");
//       setMessage({ type: "success", text: "Registration successful! Please fill your job application details." });
//     }
//   }, []);

//   useEffect(() => {
//     const fetchJob = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/jobs/view/${jobId}`);
//         if (res.data.success) {
//           const jobData = res.data.jobPost;
//           setJob(jobData);

//           if (jobData.expiryDate) {
//             const today = new Date();
//             today.setHours(0, 0, 0, 0);
//             const expiry = new Date(jobData.expiryDate);
//             if (expiry < today) {
//               setError("This job has expired and is no longer accepting applications.");
//             }
//           }
//         }
//         else setError("Job post not found.");
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to load job details.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJob();

//     // Auto-fill from token if logged in
//     const token = localStorage.getItem("candidateToken");
//     if (token) {
//       setEmailChecked(true);
//       setCandidateExists(true);
//       setIsLoggedIn(true);
//       axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } })
//         .then(profileRes => {
//           const d = profileRes.data;
//           // Split full name into first and last name
//           const nameParts = (d.name || "").split(" ");
//           const firstName = nameParts[0] || "";
//           const lastName = nameParts.slice(1).join(" ") || "";
          
//           setFormData(prev => ({
//             ...prev,
//             firstName: firstName || prev.firstName,
//             lastName: lastName || prev.lastName,
//             email: d.email || prev.email,
//             mobile: d.phone || prev.mobile,
//             address: d.address || prev.address
//           }));
//         })
//         .catch(() => { });
//     }
//   }, [jobId]);

//   const handleEmailCheck = async () => {
//     if (!formData.email) return;
//     setIsCheckingExistence(true);
//     setMessage({ type: "", text: "" });
//     setIsLoggedIn(false);
//     try {
//       const res = await axios.post(`${API_BASE}/candidate/check-existence`, { email: formData.email });
//       if (res.data.exists) {
//         setCandidateExists(true);
//         setVerificationStep("password-prompt");
//         setMessage({ type: "info", text: "Welcome back! Please enter your password to continue." });
//       } else {
//         setCandidateExists(false);
//         const otpRes = await axios.post(`${API_BASE}/candidate/send-register-otp`, { email: formData.email });
//         if (otpRes.data.success) {
//           setVerificationStep("otp-prompt");
//           setShowOtpPopup(true);
//           setMessage({ type: "success", text: "📧 OTP sent to your email. Please check and verify." });
//         }
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Something went wrong. Please try again." });
//     } finally {
//       setIsCheckingExistence(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     setErrors(prev => ({ ...prev, [name]: "" }));

//     if (name === 'firstName' || name === 'lastName') {
//       if (value && !validateAlphabetsOnly(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only alphabets and spaces allowed" }));
//       } else if (value && value.length > 20) {
//         setErrors(prev => ({ ...prev, [name]: "Maximum 20 characters allowed" }));
//       }
//     }

//     if (name === 'mobile') {
//       if (value && !/^\d*$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Only numbers allowed" }));
//       } else if (value && !/^[6-9]?\d{0,9}$/.test(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Must start with 6, 7, 8, or 9" }));
//       } else if (value && value.length === 10 && !validateMobile(value)) {
//         setErrors(prev => ({ ...prev, [name]: "Invalid mobile number format" }));
//       }
//     }

//     if (name === 'address') {
//       if (value && value.length > 100) {
//         setErrors(prev => ({ ...prev, [name]: "Maximum 100 characters allowed" }));
//       }
//     }
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 10 * 1024 * 1024) {
//         setErrors(prev => ({ ...prev, resume: "File size must be less than 10MB" }));
//         return;
//       }

//       const validTypes = [
//         'application/pdf',
//         'application/msword',
//         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//         'text/plain',
//         'application/rtf',
//         'application/vnd.oasis.opendocument.text',
//         'image/jpeg',
//         'image/png',
//         'image/gif',
//         'image/bmp',
//         'image/svg+xml',
//         'image/webp',
//         'image/tiff',
//         'image/x-icon'
//       ];

//       const validExtensions = ['.pdf', '.doc', '.docx', '.txt', '.rtf', '.odt',
//         '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp',
//         '.tiff', '.ico'];
//       const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

//       if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
//         setErrors(prev => ({ ...prev, resume: "Unsupported file format. Please upload PDF, DOC, DOCX, TXT, RTF, ODT, or image files (JPG, PNG, GIF, SVG, WEBP)" }));
//         return;
//       }

//       setFormData(prev => ({ ...prev, resume: file }));
//       setErrors(prev => ({ ...prev, resume: "" }));
//     }
//   };

//   const handleLogin = async (emailToLogin, password) => {
//     try {
//       const loginRes = await axios.post(`${API_BASE}/candidate/login`, {
//         email: emailToLogin || formData.email,
//         password: password
//       });
//       const token = loginRes.data.token;
//       const profileRes = await axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } });
//       const d = profileRes.data;
//       const nameParts = (d.name || "").split(" ");
//       const firstName = nameParts[0] || "";
//       const lastName = nameParts.slice(1).join(" ") || "";

//       setFormData(prev => ({
//         ...prev,
//         firstName: firstName || prev.firstName,
//         lastName: lastName || prev.lastName,
//         mobile: d.phone || prev.mobile,
//         address: d.address || prev.address
//       }));
//       localStorage.setItem("candidateToken", token);
//       localStorage.setItem("candidateId", d._id);
//       setIsLoggedIn(true);
//       setEmailChecked(true);
//       setVerificationStep("");
//       setMessage({ type: "success", text: "All details auto-filled from your profile! Review & apply." });
//     } catch (err) {
//       throw err;
//     }
//   };

//   const handleLoginPasswordSubmit = async (e) => {
//     if (e) e.preventDefault();
//     if (!loginPassword) {
//       setMessage({ type: "error", text: "Please enter your password." });
//       return;
//     }
//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       await handleLogin(formData.email, loginPassword);
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Invalid password. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // OTP Popup close handler
//   const handleOtpPopupClose = () => {
//     setShowOtpPopup(false);
//     setVerificationStep("");
//     setSubmitting(false);
//     setMessage({ type: "error", text: "OTP verification cancelled." });
//   };

//   const handleVerifyOtpSubmit = async (otpCode) => {
//     setOtpLoading(true);
//     setMessage({ type: "", text: "" });
//     try {
//       const res = await axios.post(`${API_BASE}/candidate/verify-register-otp`, {
//         email: formData.email,
//         otp: otpCode
//       });
//       if (res.data.success) {
//         localStorage.setItem("tempEmailForRegistration", formData.email);
//         setShowOtpPopup(false);
//         setMessage({ type: "success", text: "✅ Email verified! Redirecting to registration..." });

//         setTimeout(() => {
//           navigate(`/candidate-register/${jobId}`, {
//             state: { email: formData.email, fromJobApplication: true }
//           });
//         }, 1500);
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Invalid or expired OTP. Please try again." });
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   const handleResendOtp = async () => {
//     try {
//       const otpRes = await axios.post(`${API_BASE}/candidate/send-register-otp`, { email: formData.email });
//       if (otpRes.data.success) {
//         setMessage({ type: "success", text: "📧 New OTP sent to your email!" });
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Failed to resend OTP." });
//     }
//   };

//   const handleSubmit = async (e) => {
//     if (e) e.preventDefault();

//     const newErrors = {};
//     if (!formData.firstName) newErrors.firstName = "First name is required";
//     else if (!validateAlphabetsOnly(formData.firstName)) newErrors.firstName = "Only alphabets and spaces allowed";
//     else if (formData.firstName.length > 20) newErrors.firstName = "Maximum 20 characters allowed";

//     if (!formData.lastName) newErrors.lastName = "Last name is required";
//     else if (!validateAlphabetsOnly(formData.lastName)) newErrors.lastName = "Only alphabets and spaces allowed";
//     else if (formData.lastName.length > 20) newErrors.lastName = "Maximum 20 characters allowed";

//     if (!formData.email) newErrors.email = "Email is required";
//     else if (!validateEmail(formData.email)) newErrors.email = "Invalid email format";

//     if (!formData.mobile) newErrors.mobile = "Mobile number is required";
//     else if (!validateMobile(formData.mobile)) newErrors.mobile = "Enter 10-digit number starting with 6-9";

//     if (!formData.address) newErrors.address = "Address is required";

//     if (!formData.resume) newErrors.resume = "Please upload your resume";

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       setMessage({ type: "error", text: "Please fill all required fields" });
//       return;
//     }

//     if (job?.expiryDate) {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       const expiry = new Date(job.expiryDate);
//       if (expiry < today) {
//         setMessage({ type: "error", text: "This job has expired and cannot accept more applications." });
//         return;
//       }
//     }

//     setSubmitting(true);
//     setMessage({ type: "", text: "" });
//     try {
//       let candidateId = localStorage.getItem("candidateId");
//       let token = localStorage.getItem("candidateToken");

//       const data = new FormData();
//       data.append("jobId", job._id);
//       data.append("candidateId", candidateId);
//       data.append("firstName", formData.firstName);
//       data.append("lastName", formData.lastName);
//       data.append("email", formData.email);
//       data.append("mobile", formData.mobile);
//       data.append("address", formData.address);
//       if (formData.resume) data.append("resume", formData.resume);

//       const res = await axios.post(`${API_BASE}/applications/submit`, data, {
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (res.data.success) {
//         setMessage({ type: "success", text: "Application submitted successfully! Redirecting..." });
//         setTimeout(() => {
//           if ((job.assessmentIds && job.assessmentIds.length > 0) || job.assessmentId) {
//             const firstQuizId = job.assessmentIds?.[0]?._id || job.assessmentIds?.[0] || job.assessmentId?._id || job.assessmentId;
//             const resolvedQuizId = firstQuizId?._id || firstQuizId;
//             navigate(`/take-assessment/${jobId}/${res.data.application._id}/${resolvedQuizId}`);
//           } else {
//             navigate("/candidate-dashboard");
//           }
//         }, 2000);
//       }
//     } catch (err) {
//       setMessage({ type: "error", text: err.response?.data?.message || "Failed to submit application. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   if (loading) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)" }}>
//       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
//         <div style={{ position: "relative", width: 60, height: 60 }}>
//           <div style={{ position: "absolute", inset: 0, border: "4px solid rgba(139,92,246,0.2)", borderRadius: 16 }} />
//           <div style={{ position: "absolute", inset: 0, border: "4px solid transparent", borderTopColor: "#8b5cf6", borderRadius: 16, animation: "spin 0.8s linear infinite" }} />
//         </div>
//         <p style={{ color: "#a78bfa", fontSize: 11, fontWeight: 800, letterSpacing: "0.3em", textTransform: "uppercase" }}>Loading Application...</p>
//       </div>
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   );

//   if (error || !job) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", padding: 24 }}>
//       <div style={{ background: "#fff", borderRadius: 24, padding: 48, textAlign: "center", maxWidth: 400, width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.08)" }}>
//         <div style={{ fontSize: 48, marginBottom: 16 }}>{error.includes("expired") ? "⌛" : "⚠️"}</div>
//         <h2 style={{ fontSize: 22, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>
//           {error.includes("expired") ? "Job Expired" : "Job Not Found"}
//         </h2>
//         <p style={{ fontSize: 14, color: "#64748b", marginBottom: 24 }}>{error || "This job may have been archived."}</p>
//         <button onClick={() => navigate(-1)} style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", color: "#fff", border: "none", borderRadius: 12, padding: "12px 28px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Go Back</button>
//       </div>
//     </div>
//   );

//   const msgColors = {
//     success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d", icon: "✓" },
//     info: { bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8", icon: "ℹ" },
//     error: { bg: "#fef2f2", border: "#fecaca", text: "#dc2626", icon: "✕" },
//   };

//   // If email is checked and we have candidate details, show the application form
//   if (emailChecked && (isLoggedIn || (!candidateExists && formData.email))) {
//     return (
//       <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: "'Inter', system-ui, sans-serif" }}>
//         <style>{`
//           @keyframes spin { to { transform: rotate(360deg); } }
//           @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
//           @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//           input:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
//           @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } }
//         `}</style>

//         {message.text && (() => {
//           const mc = msgColors[message.type] || msgColors.info;
//           return (
//             <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                 <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
//                 <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
//               </div>
//               <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
//             </div>
//           );
//         })()}

//         <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
//           <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
//           <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
//           <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
//             <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
//               ← Back to Job
//             </button>
//             <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
//               <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//                 Job Application
//               </span>
//               <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//                 ✓ Position Open
//               </span>
//             </div>
//             <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
//               Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
//             </h1>
//             <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
//               {candidateExists
//                 ? "✅ Profile auto-filled — review and confirm your details below."
//                 : "📋 Fill in your details below to complete your application."}
//             </p>
//           </div>
//         </div>

//         <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
//           <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
//             <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

//             <form onSubmit={handleSubmit} style={{ padding: "36px 40px" }}>
//               {/* Personal Information - firstName, lastName, email, mobile, address */}
//               <div style={{ marginBottom: 36 }}>
//                 <SectionHeader icon="👤" title="Personal Information" subtitle="Fill your basic details" color="linear-gradient(135deg,#6366f1,#8b5cf6)" />

//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
//                   <Field label="First Name" required error={errors.firstName}>
//                     <input
//                       type="text"
//                       name="firstName"
//                       value={formData.firstName}
//                       onChange={handleChange}
//                       style={{ ...inputStyle, borderColor: errors.firstName ? "#dc2626" : "#e5e7eb" }}
//                       placeholder="Enter your first name"
//                     />
//                   </Field>

//                   <Field label="Last Name" required error={errors.lastName}>
//                     <input
//                       type="text"
//                       name="lastName"
//                       value={formData.lastName}
//                       onChange={handleChange}
//                       style={{ ...inputStyle, borderColor: errors.lastName ? "#dc2626" : "#e5e7eb" }}
//                       placeholder="Enter your last name"
//                     />
//                   </Field>
//                 </div>

//                 <div style={{ marginTop: 12 }}>
//                   <Field label="Email Address" required error={errors.email} note="We'll send a verification OTP to this email address">
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       style={{ ...inputStyle, borderColor: errors.email ? "#dc2626" : "#e5e7eb" }}
//                       placeholder="your@email.com"
//                     />
//                   </Field>
//                 </div>

//                 <div style={{ marginTop: 12 }}>
//                   <Field label="Mobile Number" required error={errors.mobile}>
//                     <input
//                       type="tel"
//                       name="mobile"
//                       value={formData.mobile}
//                       onChange={handleChange}
//                       maxLength={10}
//                       style={{ ...inputStyle, borderColor: errors.mobile ? "#dc2626" : "#e5e7eb" }}
//                       placeholder="10-digit mobile number"
//                     />
//                   </Field>
//                 </div>

//                 <div style={{ marginTop: 12 }}>
//                   <Field label="Address / Location" required error={errors.address}>
//                     <input
//                       type="text"
//                       name="address"
//                       value={formData.address}
//                       onChange={handleChange}
//                       style={{ ...inputStyle, borderColor: errors.address ? "#dc2626" : "#e5e7eb" }}
//                       placeholder="City, State, Country"
//                     />
//                   </Field>
//                 </div>
//               </div>

//               {/* Resume Upload - Click anywhere to upload */}
//               <div style={{ paddingTop: 20, borderTop: "1px solid #f1f5f9" }}>
//                 <SectionHeader icon="📄" title="Resume" subtitle="Upload your CV" color="linear-gradient(135deg,#10b981,#0ea5e9)" />

//                 <div style={{ position: "relative", cursor: "pointer" }}>
//                   <input
//                     type="file"
//                     id="resume-upload"
//                     accept=".pdf,.doc,.docx,.txt,.rtf,.odt,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/rtf,application/vnd.oasis.opendocument.text,image/*"
//                     onChange={handleFileChange}
//                     style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", zIndex: 5 }}
//                   />
//                   <div 
//                     style={{
//                       border: "2px dashed",
//                       borderColor: errors.resume ? "#dc2626" : (formData.resume ? "#6366f1" : "#cbd5e1"),
//                       borderRadius: 14,
//                       padding: "32px 20px",
//                       textAlign: "center",
//                       background: errors.resume ? "#fef2f2" : (formData.resume ? "#f5f3ff" : "#fafafa"),
//                       transition: "all 0.2s",
//                       cursor: "pointer"
//                     }}
//                     onMouseEnter={(e) => {
//                       if (!formData.resume && !errors.resume) {
//                         e.target.style.borderColor = "#6366f1";
//                         e.target.style.background = "#f5f3ff";
//                       }
//                     }}
//                     onMouseLeave={(e) => {
//                       if (!formData.resume && !errors.resume) {
//                         e.target.style.borderColor = "#cbd5e1";
//                         e.target.style.background = "#fafafa";
//                       }
//                     }}
//                   >
//                     <div style={{ fontSize: 40, marginBottom: 8 }}>{formData.resume ? "✅" : "📤"}</div>
//                     {formData.resume ? (
//                       <>
//                         <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#6366f1", wordBreak: "break-all" }}>
//                           {formData.resume.name} <span style={{ color: "#94a3b8", fontWeight: 500 }}>(ready)</span>
//                         </p>
//                         <p style={{ margin: "8px 0 0", fontSize: 11, color: "#6366f1", fontWeight: 500 }}>
//                           ✓ Click here to change or upload a different file
//                         </p>
//                       </>
//                     ) : (
//                       <>
//                         <p style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700, color: "#374151" }}>
//                           <span style={{ color: "#6366f1" }}>Click anywhere</span> to upload your resume
//                         </p>
//                         <p style={{ margin: "0 0 10px", fontSize: 13, color: "#6366f1", fontWeight: 600 }}>
//                           📎 All formats accepted — PDF, DOC, DOCX, TXT, RTF, ODT, JPG, PNG, GIF, SVG, WEBP
//                         </p>
//                         <p style={{ margin: 0, fontSize: 12, color: "#94a3b8" }}>
//                           Max file size: 10MB
//                         </p>
//                       </>
//                     )}
//                     {errors.resume && (
//                       <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, display: "block", marginTop: 8 }}>{errors.resume}</span>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 8 }}>
//                 <button
//                   type="button" onClick={() => navigate(-1)}
//                   style={{ flex: 1, minWidth: 120, padding: "14px 20px", borderRadius: 12, border: "1.5px solid #e2e8f0", background: "#fff", fontSize: 14, fontWeight: 700, color: "#475569", cursor: "pointer", transition: "all 0.2s" }}>
//                   ← Cancel
//                 </button>
//                 <button
//                   type="submit" disabled={submitting}
//                   style={{
//                     flex: 2, minWidth: 200, padding: "14px 24px", borderRadius: 12, border: "none",
//                     background: submitting ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                     color: submitting ? "#94a3b8" : "#fff",
//                     fontSize: 14, fontWeight: 800, cursor: submitting ? "not-allowed" : "pointer",
//                     display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                     boxShadow: submitting ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                     transition: "all 0.2s", letterSpacing: "0.02em"
//                   }}>
//                   {submitting
//                     ? <><span style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#6366f1", borderRadius: "50%", display: "inline-block", animation: "spin 0.7s linear infinite" }} /> Submitting...</>
//                     : <>Submit Application →</>}
//                 </button>
//               </div>
//             </form>
//           </div>

//           <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
//             Timely Health Recruitment Portal
//           </p>
//         </div>
//       </div>
//     );
//   }

//   /* ── EMAIL/OTP/PASSWORD SCREEN ── */
//   return (
//     <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "'Inter', system-ui, sans-serif" }}>
//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//         @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//         input:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
//         @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } }
//       `}</style>

//       {/* OTP Verification Popup */}
//       {showOtpPopup && (
//         <OtpPopup
//           email={formData.email}
//           onVerify={handleVerifyOtpSubmit}
//           onResend={handleResendOtp}
//           onClose={handleOtpPopupClose}
//           loading={otpLoading}
//         />
//       )}

//       {message.text && (() => {
//         const mc = msgColors[message.type] || msgColors.info;
//         return (
//           <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
//               <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
//             </div>
//             <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
//           </div>
//         );
//       })()}

//       <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
//         <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
//         <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
//         <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
//           <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
//             ← Back to Job
//           </button>
//           <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
//             <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//               Job Application
//             </span>
//             <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
//               ✓ Position Open
//             </span>
//           </div>
//           <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
//             Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
//           </h1>
//           <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
//             Enter your email to begin. Returning candidates will be auto-filled.
//           </p>
//         </div>
//       </div>

//       <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
//         <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
//           <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

//           {verificationStep === "" ? (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   📧
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter your Email</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   We'll check if you already have a profile.
//                 </p>
//               </div>

//               <div style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <Field label="Email Address" required note="We'll send a verification OTP to this email address">
//                   <div style={{ position: "relative" }}>
//                     <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>📧</span>
//                     <input
//                       type="email" name="email" required
//                       value={formData.email} onChange={handleChange}
//                       onKeyDown={e => e.key === "Enter" && handleEmailCheck()}
//                       style={{ ...inputStyle, paddingLeft: 42 }}
//                       placeholder="candidate@example.com"
//                     />
//                   </div>
//                 </Field>

//                 <button
//                   onClick={handleEmailCheck}
//                   disabled={isCheckingExistence || !formData.email}
//                   style={{
//                     width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                     background: isCheckingExistence || !formData.email ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                     color: isCheckingExistence || !formData.email ? "#94a3b8" : "#fff",
//                     fontSize: 14, fontWeight: 800, cursor: isCheckingExistence || !formData.email ? "not-allowed" : "pointer",
//                     display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                     boxShadow: isCheckingExistence || !formData.email ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                     transition: "all 0.2s", letterSpacing: "0.02em",
//                     marginTop: 16
//                   }}>
//                   {isCheckingExistence ? "Checking..." : "Continue →"}
//                 </button>
//               </div>
//             </div>
//           ) : verificationStep === "password-prompt" ? (
//             <div style={{ padding: "48px 40px" }}>
//               <div style={{ textAlign: "center", marginBottom: 36 }}>
//                 <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
//                   🔒
//                 </div>
//                 <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter Password</h2>
//                 <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
//                   Welcome back! Enter your password to load your profile.
//                 </p>
//               </div>

//               <form onSubmit={handleLoginPasswordSubmit} style={{ maxWidth: 400, margin: "0 auto" }}>
//                 <label style={labelStyle}>Password *</label>
//                 <div style={{ position: "relative", marginBottom: 20 }}>
//                   <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔒</span>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     required
//                     value={loginPassword}
//                     onChange={e => setLoginPassword(e.target.value)}
//                     style={{ ...inputStyle, paddingLeft: 42, paddingRight: 42 }}
//                     placeholder="••••••••"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", border: "none", background: "none", cursor: "pointer" }}
//                   >
//                     {showPassword ? "👁️" : "🙈"}
//                   </button>
//                 </div>

//                 <button type="submit" disabled={submitting || !loginPassword} style={{
//                   width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
//                   background: submitting || !loginPassword ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
//                   color: submitting || !loginPassword ? "#94a3b8" : "#fff",
//                   fontSize: 14, fontWeight: 800, cursor: submitting || !loginPassword ? "not-allowed" : "pointer",
//                   display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
//                   boxShadow: submitting || !loginPassword ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
//                   transition: "all 0.2s", letterSpacing: "0.02em"
//                 }}>
//                   {submitting ? "Logging in..." : "Log In & Continue →"}
//                 </button>
//               </form>
//             </div>
//           ) : null}
//         </div>

//         <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
//           Timely Health Recruitment Portal
//         </p>
//       </div>
//     </div>
//   );
// }
// export default ApplyingJob;




import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";

const API_BASE = API_BASE_URL;

/* ── Shared Input Style ─────────────────────────────────── */
const inputStyle = {
  width: "100%",
  padding: "11px 14px",
  borderRadius: 10,
  border: "1.5px solid #e5e7eb",
  fontSize: 14,
  fontWeight: 500,
  color: "#111827",
  outline: "none",
  background: "#fff",
  boxSizing: "border-box",
  transition: "border-color 0.2s",
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 700,
  color: "#6b7280",
  marginBottom: 5,
  letterSpacing: "0.03em",
};

const SectionHeader = ({ icon, title, subtitle, color = "#6366f1" }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20, paddingBottom: 14, borderBottom: "1px solid #e5e7eb", flexWrap: "wrap", overflow: "hidden" }}>
    <div style={{ width: 40, height: 40, borderRadius: 12, background: color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <span style={{ fontSize: 18 }}>{icon}</span>
    </div>
    <div style={{ flex: 1, minWidth: "100px", overflow: "hidden" }}>
      <h3 style={{ margin: 0, fontSize: 15, fontWeight: 900, color: "#111827", wordBreak: "break-word" }}>{title}</h3>
      {subtitle && <p style={{ margin: 0, fontSize: 11, color: "#9ca3af", fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase", wordBreak: "break-word" }}>{subtitle}</p>}
    </div>
  </div>
);

const Field = ({ label, children, error, required, note }) => (
  <div style={{ display: "flex", flexDirection: "column", width: "100%", overflow: "hidden" }}>
    <label style={labelStyle}>{label} {required && <span style={{ color: "#dc2626" }}>*</span>}</label>
    {children}
    {note && <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 4, fontStyle: "italic" }}>{note}</p>}
    {error && <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, marginTop: 4 }}>{error}</span>}
  </div>
);

// OTP Popup Component
const OtpPopup = ({ email, onVerify, onResend, onClose, loading }) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(30);

  useEffect(() => {
    if (resendDisabled) {
      const interval = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            setResendDisabled(false);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [resendDisabled]);

  const handleVerify = () => {
    if (!otp || otp.length !== 4) {
      setError("Please enter a valid 4-digit OTP");
      return;
    }
    setError("");
    onVerify(otp);
  };

  const handleResend = () => {
    setResendDisabled(true);
    setTimer(30);
    onResend();
  };

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(8px)",
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      animation: "fadeIn 0.3s ease"
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 24,
        maxWidth: 420,
        width: "90%",
        padding: 32,
        textAlign: "center",
        boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
        animation: "scaleIn 0.3s ease",
        position: "relative"
      }}>
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 32,
            height: 32,
            borderRadius: "50%",
            background: "#f1f5f9",
            border: "none",
            fontSize: 18,
            fontWeight: 700,
            cursor: "pointer",
            color: "#64748b",
            transition: "all 0.2s",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#e2e8f0";
            e.target.style.color = "#0f172a";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f1f5f9";
            e.target.style.color = "#64748b";
          }}
        >
          ✕
        </button>

        <div style={{
          width: 72,
          height: 72,
          background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
          borderRadius: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 16px"
        }}>
          <span style={{ fontSize: 32 }}>📧</span>
        </div>

        <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>
          Verify Your Email
        </h2>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 4 }}>
          We've sent a 4-digit verification code to
        </p>
        <p style={{ fontSize: 14, fontWeight: 700, color: "#6366f1", marginBottom: 24, wordBreak: "break-all" }}>
          {email}
        </p>

        <div style={{ marginBottom: 20 }}>
          <label style={{ ...labelStyle, textAlign: "left" }}>Enter OTP *</label>
          <input
            type="text"
            maxLength={4}
            value={otp}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, '');
              setOtp(val);
              setError("");
            }}
            style={{
              ...inputStyle,
              textAlign: "center",
              fontSize: 24,
              fontWeight: 900,
              letterSpacing: 8,
              padding: "12px",
              borderColor: error ? "#dc2626" : "#e5e7eb"
            }}
            placeholder="••••"
          />
          {error && <p style={{ fontSize: 12, color: "#dc2626", fontWeight: 600, marginTop: 6 }}>{error}</p>}
        </div>

        <button
          onClick={handleVerify}
          disabled={loading || !otp}
          style={{
            width: "100%",
            padding: "14px",
            borderRadius: 12,
            border: "none",
            background: loading || !otp ? "#e2e8f0" : "linear-gradient(135deg, #6366f1, #8b5cf6)",
            color: loading || !otp ? "#94a3b8" : "#fff",
            fontSize: 14,
            fontWeight: 800,
            cursor: loading || !otp ? "not-allowed" : "pointer",
            transition: "all 0.2s"
          }}
        >
          {loading ? "Verifying..." : "Verify & Continue →"}
        </button>

        <div style={{ marginTop: 16 }}>
          <button
            onClick={handleResend}
            disabled={resendDisabled}
            style={{
              background: "none",
              border: "none",
              color: resendDisabled ? "#94a3b8" : "#6366f1",
              fontSize: 13,
              fontWeight: 700,
              cursor: resendDisabled ? "not-allowed" : "pointer",
              transition: "all 0.2s"
            }}
          >
            {resendDisabled ? `Resend OTP in ${timer}s` : "Resend OTP"}
          </button>
        </div>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

function ApplyingJob() {
  const { id: jobId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [isCheckingExistence, setIsCheckingExistence] = useState(false);
  const [candidateExists, setCandidateExists] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const [verificationStep, setVerificationStep] = useState("");
  const [otp, setOtp] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Popup state
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  // Form data with firstName, lastName, address
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    address: "",
    resume: null
  });

  const [errors, setErrors] = useState({});

  const validateMobile = (value) => /^[6-9]\d{9}$/.test(value);
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const validateAlphabetsOnly = (value) => /^[A-Za-z\s]*$/.test(value);

  useEffect(() => {
    const registeredEmail = localStorage.getItem("registeredEmailForJob");
    if (registeredEmail && !emailChecked) {
      setFormData(prev => ({ ...prev, email: registeredEmail }));
      setEmailChecked(true);
      setCandidateExists(false);
      setVerificationStep("");
      localStorage.removeItem("registeredEmailForJob");
      setMessage({ type: "success", text: "Registration successful! Please fill your job application details." });
    }
  }, []);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const res = await axios.get(`${API_BASE}/jobs/view/${jobId}`);
        if (res.data.success) {
          const jobData = res.data.jobPost;
          setJob(jobData);

          if (jobData.expiryDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const expiry = new Date(jobData.expiryDate);
            if (expiry < today) {
              setError("This job has expired and is no longer accepting applications.");
            }
          }
        }
        else setError("Job post not found.");
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load job details.");
      } finally {
        setLoading(false);
      }
    };
    fetchJob();

    // Auto-fill from token if logged in
    const token = localStorage.getItem("candidateToken");
    if (token) {
      setEmailChecked(true);
      setCandidateExists(true);
      setIsLoggedIn(true);
      axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } })
        .then(profileRes => {
          const d = profileRes.data;
          // Split full name into first and last name
          const nameParts = (d.name || "").split(" ");
          const firstName = nameParts[0] || "";
          const lastName = nameParts.slice(1).join(" ") || "";
          
          setFormData(prev => ({
            ...prev,
            firstName: firstName || prev.firstName,
            lastName: lastName || prev.lastName,
            email: d.email || prev.email,
            mobile: d.phone || prev.mobile,
            address: d.address || prev.address
          }));
        })
        .catch(() => { });
    }
  }, [jobId]);

  const handleEmailCheck = async () => {
    if (!formData.email) return;
    setIsCheckingExistence(true);
    setMessage({ type: "", text: "" });
    setIsLoggedIn(false);
    try {
      const res = await axios.post(`${API_BASE}/candidate/check-existence`, { email: formData.email });
      if (res.data.exists) {
        setCandidateExists(true);
        setVerificationStep("password-prompt");
        setMessage({ type: "info", text: "Welcome back! Please enter your password to continue." });
      } else {
        setCandidateExists(false);
        const otpRes = await axios.post(`${API_BASE}/candidate/send-register-otp`, { email: formData.email });
        if (otpRes.data.success) {
          setVerificationStep("otp-prompt");
          setShowOtpPopup(true);
          setMessage({ type: "success", text: "📧 OTP sent to your email. Please check and verify." });
        }
      }
    } catch (err) {
      setMessage({ type: "error", text: err.response?.data?.message || "Something went wrong. Please try again." });
    } finally {
      setIsCheckingExistence(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));

    if (name === 'firstName' || name === 'lastName') {
      if (value && !validateAlphabetsOnly(value)) {
        setErrors(prev => ({ ...prev, [name]: "Only alphabets and spaces allowed" }));
      } else if (value && value.length > 20) {
        setErrors(prev => ({ ...prev, [name]: "Maximum 20 characters allowed" }));
      }
    }

    if (name === 'mobile') {
      if (value && !/^\d*$/.test(value)) {
        setErrors(prev => ({ ...prev, [name]: "Only numbers allowed" }));
      } else if (value && !/^[6-9]?\d{0,9}$/.test(value)) {
        setErrors(prev => ({ ...prev, [name]: "Must start with 6, 7, 8, or 9" }));
      } else if (value && value.length === 10 && !validateMobile(value)) {
        setErrors(prev => ({ ...prev, [name]: "Invalid mobile number format" }));
      }
    }

    if (name === 'address') {
      if (value && value.length > 100) {
        setErrors(prev => ({ ...prev, [name]: "Maximum 100 characters allowed" }));
      }
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, resume: "File size must be less than 10MB" }));
        return;
      }

      const validTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/rtf',
        'application/vnd.oasis.opendocument.text',
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp',
        'image/svg+xml',
        'image/webp',
        'image/tiff',
        'image/x-icon'
      ];

      const validExtensions = ['.pdf', '.doc', '.docx', '.txt', '.rtf', '.odt',
        '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp',
        '.tiff', '.ico'];
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

      if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
        setErrors(prev => ({ ...prev, resume: "Unsupported file format. Please upload PDF, DOC, DOCX, TXT, RTF, ODT, or image files (JPG, PNG, GIF, SVG, WEBP)" }));
        return;
      }

      setFormData(prev => ({ ...prev, resume: file }));
      setErrors(prev => ({ ...prev, resume: "" }));
    }
  };

  const handleLogin = async (emailToLogin, password) => {
    try {
      const loginRes = await axios.post(`${API_BASE}/candidate/login`, {
        email: emailToLogin || formData.email,
        password: password
      });
      const token = loginRes.data.token;
      const profileRes = await axios.get(`${API_BASE}/candidate/profile`, { headers: { Authorization: `Bearer ${token}` } });
      const d = profileRes.data;
      const nameParts = (d.name || "").split(" ");
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      setFormData(prev => ({
        ...prev,
        firstName: firstName || prev.firstName,
        lastName: lastName || prev.lastName,
        mobile: d.phone || prev.mobile,
        address: d.address || prev.address
      }));
      localStorage.setItem("candidateToken", token);
      localStorage.setItem("candidateId", d._id);
      setIsLoggedIn(true);
      setEmailChecked(true);
      setVerificationStep("");
      setMessage({ type: "success", text: "All details auto-filled from your profile! Review & apply." });
    } catch (err) {
      throw err;
    }
  };

  const handleLoginPasswordSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!loginPassword) {
      setMessage({ type: "error", text: "Please enter your password." });
      return;
    }
    setSubmitting(true);
    setMessage({ type: "", text: "" });
    try {
      await handleLogin(formData.email, loginPassword);
    } catch (err) {
      setMessage({ type: "error", text: err.response?.data?.message || "Invalid password. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  // OTP Popup close handler
  const handleOtpPopupClose = () => {
    setShowOtpPopup(false);
    setVerificationStep("");
    setSubmitting(false);
    setMessage({ type: "error", text: "OTP verification cancelled." });
  };

  const handleVerifyOtpSubmit = async (otpCode) => {
    setOtpLoading(true);
    setMessage({ type: "", text: "" });
    try {
      const res = await axios.post(`${API_BASE}/candidate/verify-register-otp`, {
        email: formData.email,
        otp: otpCode
      });
      if (res.data.success) {
        localStorage.setItem("tempEmailForRegistration", formData.email);
        setShowOtpPopup(false);
        setMessage({ type: "success", text: "✅ Email verified! Redirecting to registration..." });

        setTimeout(() => {
          navigate(`/candidate-register/${jobId}`, {
            state: { email: formData.email, fromJobApplication: true }
          });
        }, 1500);
      }
    } catch (err) {
      setMessage({ type: "error", text: err.response?.data?.message || "Invalid or expired OTP. Please try again." });
    } finally {
      setOtpLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      const otpRes = await axios.post(`${API_BASE}/candidate/send-register-otp`, { email: formData.email });
      if (otpRes.data.success) {
        setMessage({ type: "success", text: "📧 New OTP sent to your email!" });
      }
    } catch (err) {
      setMessage({ type: "error", text: err.response?.data?.message || "Failed to resend OTP." });
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First name is required";
    else if (!validateAlphabetsOnly(formData.firstName)) newErrors.firstName = "Only alphabets and spaces allowed";
    else if (formData.firstName.length > 20) newErrors.firstName = "Maximum 20 characters allowed";

    if (!formData.lastName) newErrors.lastName = "Last name is required";
    else if (!validateAlphabetsOnly(formData.lastName)) newErrors.lastName = "Only alphabets and spaces allowed";
    else if (formData.lastName.length > 20) newErrors.lastName = "Maximum 20 characters allowed";

    if (!formData.email) newErrors.email = "Email is required";
    else if (!validateEmail(formData.email)) newErrors.email = "Invalid email format";

    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    else if (!validateMobile(formData.mobile)) newErrors.mobile = "Enter 10-digit number starting with 6-9";

    if (!formData.address) newErrors.address = "Address is required";

    if (!formData.resume) newErrors.resume = "Please upload your resume";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setMessage({ type: "error", text: "Please fill all required fields" });
      return;
    }

    if (job?.expiryDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const expiry = new Date(job.expiryDate);
      if (expiry < today) {
        setMessage({ type: "error", text: "This job has expired and cannot accept more applications." });
        return;
      }
    }

    setSubmitting(true);
    setMessage({ type: "", text: "" });
    try {
      let candidateId = localStorage.getItem("candidateId");
      let token = localStorage.getItem("candidateToken");

      const data = new FormData();
      data.append("jobId", job._id);
      data.append("candidateId", candidateId);
      data.append("firstName", formData.firstName);
      data.append("lastName", formData.lastName);
      data.append("email", formData.email);
      data.append("mobile", formData.mobile);
      data.append("address", formData.address);
      if (formData.resume) data.append("resume", formData.resume);

      const res = await axios.post(`${API_BASE}/applications/submit`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (res.data.success) {
        setMessage({ type: "success", text: "Application submitted successfully! Redirecting..." });
        setTimeout(() => {
          if ((job.assessmentIds && job.assessmentIds.length > 0) || job.assessmentId) {
            const firstQuizId = job.assessmentIds?.[0]?._id || job.assessmentIds?.[0] || job.assessmentId?._id || job.assessmentId;
            const resolvedQuizId = firstQuizId?._id || firstQuizId;
            navigate(`/take-assessment/${jobId}/${res.data.application._id}/${resolvedQuizId}`);
          } else {
            navigate("/candidate-dashboard");
          }
        }, 2000);
      }
    } catch (err) {
      setMessage({ type: "error", text: err.response?.data?.message || "Failed to submit application. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        <div style={{ position: "relative", width: 60, height: 60 }}>
          <div style={{ position: "absolute", inset: 0, border: "4px solid rgba(139,92,246,0.2)", borderRadius: 16 }} />
          <div style={{ position: "absolute", inset: 0, border: "4px solid transparent", borderTopColor: "#8b5cf6", borderRadius: 16, animation: "spin 0.8s linear infinite" }} />
        </div>
        <p style={{ color: "#a78bfa", fontSize: 11, fontWeight: 800, letterSpacing: "0.3em", textTransform: "uppercase" }}>Loading Application...</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  if (error || !job) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: 48, textAlign: "center", maxWidth: 400, width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.08)" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>{error.includes("expired") ? "⌛" : "⚠️"}</div>
        <h2 style={{ fontSize: 22, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>
          {error.includes("expired") ? "Job Expired" : "Job Not Found"}
        </h2>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 24 }}>{error || "This job may have been archived."}</p>
        <button onClick={() => navigate(-1)} style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", color: "#fff", border: "none", borderRadius: 12, padding: "12px 28px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Go Back</button>
      </div>
    </div>
  );

  const msgColors = {
    success: { bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d", icon: "✓" },
    info: { bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8", icon: "ℹ" },
    error: { bg: "#fef2f2", border: "#fecaca", text: "#dc2626", icon: "✕" },
  };

  // If email is checked and we have candidate details, show the application form
  if (emailChecked && (isLoggedIn || (!candidateExists && formData.email))) {
    return (
      <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: "'Inter', system-ui, sans-serif" }}>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
          @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
          input:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
          @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } }
        `}</style>

        {message.text && (() => {
          const mc = msgColors[message.type] || msgColors.info;
          return (
            <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
                <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
              </div>
              <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
            </div>
          );
        })()}

        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
          <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
              ← Back to Job
            </button>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
              <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
                Job Application
              </span>
              <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
                ✓ Position Open
              </span>
            </div>
            <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
              Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
            </h1>
            <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
              {candidateExists
                ? "✅ Profile auto-filled — review and confirm your details below."
                : "📋 Fill in your details below to complete your application."}
            </p>
          </div>
        </div>

        <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
          <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
            <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

            <form onSubmit={handleSubmit} style={{ padding: "36px 40px" }}>
              {/* Personal Information - firstName, lastName, email, mobile, address */}
              <div style={{ marginBottom: 36 }}>
                <SectionHeader icon="👤" title="Personal Information" subtitle="Fill your basic details" color="linear-gradient(135deg,#6366f1,#8b5cf6)" />

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                  <Field label="First Name" required error={errors.firstName}>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      style={{ ...inputStyle, borderColor: errors.firstName ? "#dc2626" : "#e5e7eb" }}
                      placeholder="Enter your first name"
                    />
                  </Field>

                  <Field label="Last Name" required error={errors.lastName}>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      style={{ ...inputStyle, borderColor: errors.lastName ? "#dc2626" : "#e5e7eb" }}
                      placeholder="Enter your last name"
                    />
                  </Field>
                </div>

                <div style={{ marginTop: 12 }}>
                  <Field label="Email Address" required error={errors.email} note="We'll send a verification OTP to this email address">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      style={{ ...inputStyle, borderColor: errors.email ? "#dc2626" : "#e5e7eb" }}
                      placeholder="your@email.com"
                    />
                  </Field>
                </div>

                <div style={{ marginTop: 12 }}>
                  <Field label="Mobile Number" required error={errors.mobile}>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      maxLength={10}
                      style={{ ...inputStyle, borderColor: errors.mobile ? "#dc2626" : "#e5e7eb" }}
                      placeholder="10-digit mobile number"
                    />
                  </Field>
                </div>

                <div style={{ marginTop: 12 }}>
                  <Field label="Address / Location" required error={errors.address}>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      style={{ ...inputStyle, borderColor: errors.address ? "#dc2626" : "#e5e7eb" }}
                      placeholder="City, State, Country"
                    />
                  </Field>
                </div>
              </div>

              {/* Resume Upload - Click anywhere to upload */}
              <div style={{ paddingTop: 20, borderTop: "1px solid #f1f5f9" }}>
                <SectionHeader icon="📄" title="Resume" subtitle="Upload your CV" color="linear-gradient(135deg,#10b981,#0ea5e9)" />

                <div style={{ position: "relative", cursor: "pointer" }}>
                  <input
                    type="file"
                    id="resume-upload"
                    accept=".pdf,.doc,.docx,.txt,.rtf,.odt,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/rtf,application/vnd.oasis.opendocument.text,image/*"
                    onChange={handleFileChange}
                    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", zIndex: 5 }}
                  />
                  <div 
                    style={{
                      border: "2px dashed",
                      borderColor: errors.resume ? "#dc2626" : (formData.resume ? "#6366f1" : "#cbd5e1"),
                      borderRadius: 14,
                      padding: "32px 20px",
                      textAlign: "center",
                      background: errors.resume ? "#fef2f2" : (formData.resume ? "#f5f3ff" : "#fafafa"),
                      transition: "all 0.2s",
                      cursor: "pointer"
                    }}
                    onMouseEnter={(e) => {
                      if (!formData.resume && !errors.resume) {
                        e.target.style.borderColor = "#6366f1";
                        e.target.style.background = "#f5f3ff";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!formData.resume && !errors.resume) {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.background = "#fafafa";
                      }
                    }}
                  >
                    <div style={{ fontSize: 40, marginBottom: 8 }}>{formData.resume ? "✅" : "📤"}</div>
                    {formData.resume ? (
                      <>
                        <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#6366f1", wordBreak: "break-all" }}>
                          {formData.resume.name} <span style={{ color: "#94a3b8", fontWeight: 500 }}>(ready)</span>
                        </p>
                        <p style={{ margin: "8px 0 0", fontSize: 11, color: "#6366f1", fontWeight: 500 }}>
                          ✓ Click here to change or upload a different file
                        </p>
                      </>
                    ) : (
                      <>
                        <p style={{ margin: "0 0 6px", fontSize: 15, fontWeight: 700, color: "#374151" }}>
                          <span style={{ color: "#6366f1" }}>Click anywhere</span> to upload your resume
                        </p>
                        <p style={{ margin: "0 0 10px", fontSize: 13, color: "#6366f1", fontWeight: 600 }}>
                          📎 All formats accepted — PDF, DOC, DOCX, TXT, RTF, ODT, JPG, PNG, GIF, SVG, WEBP
                        </p>
                        <p style={{ margin: 0, fontSize: 12, color: "#94a3b8" }}>
                          Max file size: 10MB
                        </p>
                      </>
                    )}
                    {errors.resume && (
                      <span style={{ fontSize: 11, color: "#dc2626", fontWeight: 600, display: "block", marginTop: 8 }}>{errors.resume}</span>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 8 }}>
                <button
                  type="button" onClick={() => navigate(-1)}
                  style={{ flex: 1, minWidth: 120, padding: "14px 20px", borderRadius: 12, border: "1.5px solid #e2e8f0", background: "#fff", fontSize: 14, fontWeight: 700, color: "#475569", cursor: "pointer", transition: "all 0.2s" }}>
                  ← Cancel
                </button>
                <button
                  type="submit" disabled={submitting}
                  style={{
                    flex: 2, minWidth: 200, padding: "14px 24px", borderRadius: 12, border: "none",
                    background: submitting ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
                    color: submitting ? "#94a3b8" : "#fff",
                    fontSize: 14, fontWeight: 800, cursor: submitting ? "not-allowed" : "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                    boxShadow: submitting ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
                    transition: "all 0.2s", letterSpacing: "0.02em"
                  }}>
                  {submitting
                    ? <><span style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#6366f1", borderRadius: "50%", display: "inline-block", animation: "spin 0.7s linear infinite" }} /> Submitting...</>
                    : <>Submit Application →</>}
                </button>
              </div>
            </form>
          </div>

          <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
            Timely Health Recruitment Portal
          </p>
        </div>
      </div>
    );
  }

  /* ── EMAIL/OTP/PASSWORD SCREEN ── */
  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        input:focus { border-color: #6366f1 !important; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
        @media (max-width: 640px) { .hero-title { font-size: 22px !important; } .form-card { padding: 20px !important; } }
      `}</style>

      {/* OTP Verification Popup */}
      {showOtpPopup && (
        <OtpPopup
          email={formData.email}
          onVerify={handleVerifyOtpSubmit}
          onResend={handleResendOtp}
          onClose={handleOtpPopupClose}
          loading={otpLoading}
        />
      )}

      {message.text && (() => {
        const mc = msgColors[message.type] || msgColors.info;
        return (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000, background: mc.bg, borderBottom: `2px solid ${mc.border}`, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", animation: "fadeDown 0.3s ease", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ width: 24, height: 24, borderRadius: "50%", background: mc.text, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 900, flexShrink: 0 }}>{mc.icon}</span>
              <span style={{ fontSize: 14, fontWeight: 700, color: mc.text }}>{message.text}</span>
            </div>
            <button onClick={() => setMessage({ type: "", text: "" })} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: mc.text, opacity: 0.7, lineHeight: 1, padding: "0 4px", flexShrink: 0 }}>×</button>
          </div>
        );
      })()}

      <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 55%, #312e81 100%)", padding: "56px 24px 72px", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(139,92,246,0.1)", filter: "blur(60px)", pointerEvents: "none" }} />
        <div style={{ position: "absolute", bottom: -40, left: -40, width: 250, height: 250, borderRadius: "50%", background: "rgba(99,102,241,0.08)", filter: "blur(50px)", pointerEvents: "none" }} />
        <div style={{ maxWidth: 780, margin: "0 auto", position: "relative", zIndex: 1 }}>
          <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
            ← Back to Job
          </button>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 }}>
            <span style={{ background: "rgba(99,102,241,0.25)", color: "#c4b5fd", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
              Job Application
            </span>
            <span style={{ background: "rgba(16,185,129,0.2)", color: "#6ee7b7", border: "1px solid rgba(16,185,129,0.3)", borderRadius: 8, padding: "4px 14px", fontSize: 10, fontWeight: 800, letterSpacing: "0.15em", textTransform: "uppercase" }}>
              ✓ Position Open
            </span>
          </div>
          <h1 className="hero-title" style={{ color: "#fff", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.2, margin: "0 0 12px" }}>
            Apply for <span style={{ color: "#a78bfa" }}>{job.role}</span>
          </h1>
          <p style={{ color: "#94a3b8", fontSize: 14, fontWeight: 500, margin: 0 }}>
            Enter your email to begin. Returning candidates will be auto-filled.
          </p>
        </div>
      </div>

      <div style={{ maxWidth: 780, margin: "-40px auto 80px", padding: "0 16px", position: "relative", zIndex: 10 }}>
        <div className="form-card" style={{ background: "#fff", borderRadius: 24, boxShadow: "0 8px 40px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", overflow: "hidden", animation: "fadeUp 0.4s ease" }}>
          <div style={{ height: 5, background: "linear-gradient(90deg,#6366f1,#8b5cf6,#d946ef)" }} />

          {verificationStep === "" ? (
            <div style={{ padding: "48px 40px" }}>
              <div style={{ textAlign: "center", marginBottom: 36 }}>
                <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
                  📧
                </div>
                <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter your Email</h2>
                <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
                  We'll check if you already have a profile.
                </p>
              </div>

              <div style={{ maxWidth: 400, margin: "0 auto" }}>
                <Field label="Email Address" required note="We'll send a verification OTP to this email address">
                  <div style={{ position: "relative" }}>
                    <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>📧</span>
                    <input
                      type="email" name="email" required
                      value={formData.email} onChange={handleChange}
                      onKeyDown={e => e.key === "Enter" && handleEmailCheck()}
                      style={{ ...inputStyle, paddingLeft: 42 }}
                      placeholder="candidate@example.com"
                    />
                  </div>
                </Field>

                <button
                  onClick={handleEmailCheck}
                  disabled={isCheckingExistence || !formData.email}
                  style={{
                    width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
                    background: isCheckingExistence || !formData.email ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
                    color: isCheckingExistence || !formData.email ? "#94a3b8" : "#fff",
                    fontSize: 14, fontWeight: 800, cursor: isCheckingExistence || !formData.email ? "not-allowed" : "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                    boxShadow: isCheckingExistence || !formData.email ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
                    transition: "all 0.2s", letterSpacing: "0.02em",
                    marginTop: 16
                  }}>
                  {isCheckingExistence ? "Checking..." : "Continue →"}
                </button>
              </div>
            </div>
          ) : verificationStep === "password-prompt" ? (
            <div style={{ padding: "48px 40px" }}>
              <div style={{ textAlign: "center", marginBottom: 36 }}>
                <div style={{ width: 72, height: 72, background: "linear-gradient(135deg,#eef2ff,#f3e8ff)", border: "1px solid #ddd6fe", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>
                  🔒
                </div>
                <h2 style={{ fontSize: 20, fontWeight: 900, color: "#0f172a", margin: "0 0 8px" }}>Enter Password</h2>
                <p style={{ fontSize: 13, color: "#64748b", margin: 0, lineHeight: 1.6 }}>
                  Welcome back! Enter your password to load your profile.
                </p>
              </div>

              <form onSubmit={handleLoginPasswordSubmit} style={{ maxWidth: 400, margin: "0 auto" }}>
                <label style={labelStyle}>Password *</label>
                <div style={{ position: "relative", marginBottom: 20 }}>
                  <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔒</span>
                  <input
                    type={showPassword ? "text" : "password"}
                    required
                    value={loginPassword}
                    onChange={e => setLoginPassword(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: 42, paddingRight: 42 }}
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", border: "none", background: "none", cursor: "pointer" }}
                  >
                    {showPassword ? "👁️" : "🙈"}
                  </button>
                </div>

                <button type="submit" disabled={submitting || !loginPassword} style={{
                  width: "100%", padding: "14px 24px", borderRadius: 12, border: "none",
                  background: submitting || !loginPassword ? "#e2e8f0" : "linear-gradient(135deg,#6366f1,#8b5cf6)",
                  color: submitting || !loginPassword ? "#94a3b8" : "#fff",
                  fontSize: 14, fontWeight: 800, cursor: submitting || !loginPassword ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                  boxShadow: submitting || !loginPassword ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
                  transition: "all 0.2s", letterSpacing: "0.02em"
                }}>
                  {submitting ? "Logging in..." : "Log In & Continue →"}
                </button>
              </form>
            </div>
          ) : null}
        </div>

        <p style={{ textAlign: "center", marginTop: 24, fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.2em", textTransform: "uppercase" }}>
          Timely Health Recruitment Portal
        </p>
      </div>
    </div>
  );
}
export default ApplyingJob;